/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)

// グローバル変数
let needsReinitAfterRender = false;

// 利用日設定
function initializeDatepicker() {
  const $datepicker = $("#datepicker");

  if ($datepicker.length === 0) {
    return;
  }

  if ($.data($datepicker[0], "datepicker")) {
    $datepicker.datepicker("destroy").removeData("datepicker");
  }

  $datepicker.datepicker({
    dateFormat: "yy-mm-dd",
    onSelect: function() {
      // 日付が選択されたら×ボタンを表示
      $("#datepicker_clear").show();
    }
  });

  // 既に値が入っている場合は×ボタンを表示
  if ($datepicker.val() !== "") {
    $("#datepicker_clear").show();
  }

  $datepicker.off("focus").on("focus", function () {
    if ($.data(this, "datepicker")) {
      $(this).datepicker("show");
    }
  });
}

document.addEventListener("turbo:before-render", function () {
  const $datepicker = $("#datepicker");
  if ($datepicker.length && $.data($datepicker[0], "datepicker")) {
    $datepicker.datepicker("destroy").removeData("datepicker");
  }
});

document.addEventListener("turbo:load", initializeDatepicker);

// リンク型決済フォーム 自動submit実行
function submitLinkTypePaymentForm() {
  const $form = $("#reservation_linkForm");

  if ($form.length === 0) {
    return;
  }

  // サブミット前に決済サイトからブラウザバックされてきたときの動作を定義しておく
  window.addEventListener("pageshow", function (event) {
    if (event.persisted) {
      backReservationFormFromLinkTypePaymentForm();
    }
  });

  $form.submit();
}

document.addEventListener("turbo:load", submitLinkTypePaymentForm);

// リンク型決済フォーム ブラウザバックされた場合は予約フォームへ戻る
function backReservationFormFromLinkTypePaymentForm() {
  const $backLink = $("#backReservationFormUrlLink");

  if ($backLink.length === 0) {
    return;
  }

  let backUrl = $backLink.attr("href");
  if (!backUrl) {
    backUrl = "/";
  }

  window.location.href = backUrl;
}

function initialize() {
  // ajax用設定
  $.ajaxSetup({
    headers: {
      "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content"),
    },
  });

  // TOP バリデーション実装（イベント委譲を使用してページ遷移後も動作するように修正）
  $(document).off("click", "#search_button").on("click", "#search_button", function (e) {
    const dateVal = $("#datepicker").val();
    
    // 各時間セレクトボックスが選択されているか（disabledでないか）
    const isStartHourSelected   = !$("#start_hour option:selected").is(":disabled");
    const isStartMinuteSelected = !$("#start_minute option:selected").is(":disabled");
    const isEndHourSelected     = !$("#end_hour option:selected").is(":disabled");
    const isEndMinuteSelected   = !$("#end_minute option:selected").is(":disabled");

    // 全て選択されているか、およびいずれか1つでも選択されているか
    const isTimeAllSelected = isStartHourSelected && isStartMinuteSelected && isEndHourSelected && isEndMinuteSelected;
    const isTimeAnySelected = isStartHourSelected || isStartMinuteSelected || isEndHourSelected || isEndMinuteSelected;

    if (dateVal !== "" && !isTimeAllSelected) {
      // 日付はあるが時間がすべて揃っていない場合
      $(".input_errMessage-date").text("※時間を選択してください").show();
      e.preventDefault();
    } else if (dateVal === "" && isTimeAnySelected) {
      // 時間が1つでも選択されているが日付がない場合
      $(".input_errMessage-date").text("※日付を選択してください").show();
      e.preventDefault();
    } else {
      // 両方ある、または両方ない場合（エラーなし）
      $(".input_errMessage-date").hide();
    }
  });

  // 駅徒歩の「指定なし」がクリックされた時、他の選択肢を外す
  $(document).off("change", ".js-walking-none").on("change", ".js-walking-none", function() {
    if ($(this).is(":checked")) {
      $("input[name='walking_minute']").prop("checked", false);
    }
  });

  // 駅徒歩の「5分以内」などがクリックされた時、「指定なし」を外す
  $(document).off("change", "input[name='walking_minute']").on("change", "input[name='walking_minute']", function() {
    if ($(this).is(":checked")) {
      $(".js-walking-none").prop("checked", false);
    }
  });

  // モーダル表示処理
  // 検索画面表示（イベント委譲を使用してページ遷移後も動作するように修正）
  $(document).off("click", ".search_criteria").on("click", ".search_criteria", function () {
    $("#searchPopup, .searchPopup_overlay").toggleClass("active");
    // ポップアップが表示された後に、ポップアップ内のアイコンを初期化
    if ($("#searchPopup").hasClass("active")) {
      // 背景のスクロールを無効化
      $("body").css("overflow", "hidden");
      // ポップアップの高さを調整（スクロール可能にするため）
      const $popup = $("#searchPopup");
      const viewportHeight = $(window).height();
      const maxHeight = viewportHeight - 120;
      $popup.css("max-height", maxHeight + "px");
      
      setTimeout(function() {
        // ポップアップ内のアイコンとサイズを初期化
        $("#searchPopup .freeword-icon").each(function() {
          const $icon = $(this);
          // 初期化フラグをリセット（ポップアップ表示のたびに再初期化）
          $icon.removeData("tooltip-initialized");
        });
        $("#searchPopup .search_radio-group").each(function() {
          $(this).removeData("size-fixed");
        });
        // 初期化実行
        fixRadioGroupSizes();
        initFreewordIcons();
      }, 50);
    } else {
      // 背景のスクロールを再度有効化
      $("body").css("overflow", "");
    }
  });

  // 検索欄 詳細表示（詳細条件ボタン、閉じるボタン、オーバーレイのクリック）
  // イベント委譲を使用し、重複登録を防ぐために既存のイベントリスナーを削除してから再登録
  $(document).off("click", ".details-button").on("click", ".details-button", function (e) {
    e.stopPropagation();
    const isOpening = !$(".popup_overlay").hasClass("active");
    
    const $popup = $("#popup");
    const $popupOverlay = $(".popup_overlay");
    const $searchPopup = $("#searchPopup");
    
    if (isOpening && $popup.length > 0 && $popupOverlay.length > 0) {
      // 親ポップアップがスクロール可能かどうかを判定
      const needsScroll = $searchPopup.length > 0 && $searchPopup[0].scrollHeight > $searchPopup[0].clientHeight;
      
      if (needsScroll) {
        // スクロールが必要な場合のみ、bodyの直接の子要素として移動
        // これにより、親ポップアップのtransformの影響を受けなくなる
        if (!$popup.data("original-parent")) {
          $popup.data("original-parent", $popup.parent());
        }
        if (!$popupOverlay.data("original-parent")) {
          $popupOverlay.data("original-parent", $popupOverlay.parent());
        }
        
        // bodyの直接の子要素として移動
        $popup.appendTo("body");
        $popupOverlay.appendTo("body");
      } else {
        // スクロールが不要な場合は、元の位置に戻す（既に移動している場合）
        const originalParentPopup = $popup.data("original-parent");
        const originalParentOverlay = $popupOverlay.data("original-parent");
        
        if (originalParentPopup && originalParentPopup.length > 0) {
          $popup.appendTo(originalParentPopup);
        }
        if (originalParentOverlay && originalParentOverlay.length > 0) {
          $popupOverlay.appendTo(originalParentOverlay);
        }
      }
    }

    $("#popup, .popup_overlay").toggleClass("active");
    // 詳細条件ポップアップの表示状態に応じてsearchPopupのバツボタンを無効化/有効化
    if ($(".popup_overlay").hasClass("active")) {
      // searchPopupが存在する場合はバツボタンを無効化
      if ($("#searchPopup").length > 0) {
        $("#searchPopup > .popup_close_icon").addClass("disabled");
        // スクロールが必要な場合のみ暗くする
        if (isOpening) {
          const needsScroll = $searchPopup[0].scrollHeight > $searchPopup[0].clientHeight;
          if (needsScroll) {
            $("#searchPopup").addClass("dimmed");
          }
        } else {
          // 既に開いている状態で再度開く場合は、現在のスクロール状態を確認
          const needsScroll = $searchPopup[0].scrollHeight > $searchPopup[0].clientHeight;
          if (needsScroll) {
            $("#searchPopup").addClass("dimmed");
          } else {
            $("#searchPopup").removeClass("dimmed");
          }
        }
      }
      // searchPopupが開いていない場合は背景のスクロールを無効化
      if (!$("#searchPopup").hasClass("active")) {
        $("body").css({
          "overflow": "hidden",
          "overscroll-behavior": "none",
          "touch-action": "pan-y"
        });
      }
      // ポップアップ内のスクロール時に背景が動かないようにする
      $("#popup").on("touchmove", function(e) {
        e.stopPropagation();
      });
    } else {
      // 詳細条件ポップアップとオーバーレイを元の位置に戻す（移動していた場合のみ）
      if ($popup.length > 0 && $popupOverlay.length > 0) {
        const originalParentPopup = $popup.data("original-parent");
        const originalParentOverlay = $popupOverlay.data("original-parent");
        
        if (originalParentPopup && originalParentPopup.length > 0) {
          $popup.appendTo(originalParentPopup);
        }
        if (originalParentOverlay && originalParentOverlay.length > 0) {
          $popupOverlay.appendTo(originalParentOverlay);
        }
      }
      
      // searchPopupが存在する場合はバツボタンを有効化し、暗くするクラスを削除
      if ($("#searchPopup").length > 0) {
        $("#searchPopup > .popup_close_icon").removeClass("disabled");
        $("#searchPopup").removeClass("dimmed");
      }
      // searchPopupが開いていない場合は背景のスクロールを再度有効化
      if (!$("#searchPopup").hasClass("active")) {
        $("body").css({
          "overflow": "",
          "overscroll-behavior": "",
          "touch-action": ""
        });
      }
      // イベントリスナーを削除
      $("#popup").off("touchmove");
    }
  });

  // 詳細条件ポップアップのバツボタン（専用処理）
  $(document).off("click", "#popup .popup_close_icon").on("click", "#popup .popup_close_icon", function (e) {
    e.stopPropagation();
    e.preventDefault();
    // 詳細条件ポップアップだけを閉じる
    $("#popup, .popup_overlay").removeClass("active");
    
    // 詳細条件ポップアップとオーバーレイを元の位置に戻す
    const $popup = $("#popup");
    const $popupOverlay = $(".popup_overlay");
    
    if ($popup.length > 0 && $popupOverlay.length > 0) {
      const originalParentPopup = $popup.data("original-parent");
      const originalParentOverlay = $popupOverlay.data("original-parent");
      
      if (originalParentPopup && originalParentPopup.length > 0) {
        $popup.appendTo(originalParentPopup);
      }
      if (originalParentOverlay && originalParentOverlay.length > 0) {
        $popupOverlay.appendTo(originalParentOverlay);
      }
    }
    
    // searchPopupが存在する場合はバツボタンを有効化
    if ($("#searchPopup").length > 0) {
      $("#searchPopup > .popup_close_icon").removeClass("disabled");
      $("#searchPopup").removeClass("dimmed");
    }
    // searchPopupが開いていない場合は背景のスクロールを再度有効化
    if (!$("#searchPopup").hasClass("active")) {
      $("body").css({
        "overflow": "",
        "overscroll-behavior": "",
        "touch-action": ""
      });
    }
    // イベントリスナーを削除
    $("#popup").off("touchmove");
    return false;
  });

  // 詳細条件ポップアップの閉じるボタン
  $(document).off("click", ".popup_close").on("click", ".popup_close", function (e) {
    e.stopPropagation();
    $("#popup, .popup_overlay").removeClass("active");
    
    // 詳細条件ポップアップとオーバーレイを元の位置に戻す
    const $popup = $("#popup");
    const $popupOverlay = $(".popup_overlay");
    
    if ($popup.length > 0 && $popupOverlay.length > 0) {
      const originalParentPopup = $popup.data("original-parent");
      const originalParentOverlay = $popupOverlay.data("original-parent");
      
      if (originalParentPopup && originalParentPopup.length > 0) {
        $popup.appendTo(originalParentPopup);
      }
      if (originalParentOverlay && originalParentOverlay.length > 0) {
        $popupOverlay.appendTo(originalParentOverlay);
      }
    }
    
    // searchPopupが存在する場合はバツボタンを有効化
    if ($("#searchPopup").length > 0) {
      $("#searchPopup > .popup_close_icon").removeClass("disabled");
      $("#searchPopup").removeClass("dimmed");
    }
    // searchPopupが開いていない場合は背景のスクロールを再度有効化
    if (!$("#searchPopup").hasClass("active")) {
      $("body").css({
        "overflow": "",
        "overscroll-behavior": "",
        "touch-action": ""
      });
    }
    // イベントリスナーを削除
    $("#popup").off("touchmove");
  });

  // ポップアップオーバーレイのクリック
  $(document).off("click", ".popup_overlay").on("click", ".popup_overlay", function (e) {
    e.stopPropagation();
    $("#popup, .popup_overlay").removeClass("active");
    
    // 詳細条件ポップアップとオーバーレイを元の位置に戻す
    const $popup = $("#popup");
    const $popupOverlay = $(".popup_overlay");
    
    if ($popup.length > 0 && $popupOverlay.length > 0) {
      const originalParentPopup = $popup.data("original-parent");
      const originalParentOverlay = $popupOverlay.data("original-parent");
      
      if (originalParentPopup && originalParentPopup.length > 0) {
        $popup.appendTo(originalParentPopup);
      }
      if (originalParentOverlay && originalParentOverlay.length > 0) {
        $popupOverlay.appendTo(originalParentOverlay);
      }
    }
    
    // searchPopupが存在する場合はバツボタンを有効化
    if ($("#searchPopup").length > 0) {
      $("#searchPopup > .popup_close_icon").removeClass("disabled");
      $("#searchPopup").removeClass("dimmed");
    }
    // searchPopupが開いていない場合は背景のスクロールを再度有効化
    if (!$("#searchPopup").hasClass("active")) {
      $("body").css({
        "overflow": "",
        "overscroll-behavior": "",
        "touch-action": ""
      });
    }
    // イベントリスナーを削除
    $("#popup").off("touchmove");
  });

  // searchPopup内の閉じるボタン
  $(document).off("click", "#searchPopup > .popup_close_icon").on("click", "#searchPopup > .popup_close_icon", function (e) {
    e.stopPropagation();
    // 詳細条件ポップアップが表示されている場合は何もしない
    if ($(".popup_overlay").hasClass("active") || $(this).hasClass("disabled")) {
      return false;
    }
    $("#searchPopup, .searchPopup_overlay").removeClass("active");
    // 背景のスクロールを再度有効化
    $("body").css("overflow", "");
  });

  $(document).off("click", ".searchPopup_overlay").on("click", ".searchPopup_overlay", function () {
    if ($(".popup_overlay").hasClass("active") && $(".searchPopup_overlay").hasClass("active")) {
      $("#popup, .popup_overlay").removeClass("active");
      $("#searchPopup > .popup_close_icon").removeClass("disabled");
      // 詳細条件ポップアップが閉じられたが、searchPopupは開いているので背景のスクロールは無効化のまま
    } else {
      $("#searchPopup, .searchPopup_overlay").removeClass("active");
      // 背景のスクロールを再度有効化
      $("body").css("overflow", "");
    }
  });

  // 検索画面表示（イベント委譲を使用してページ遷移後も動作するように修正）
  $(document).off("click", ".img_favorite").on("click", ".img_favorite", function (e) {
    e.preventDefault();

    const currentSrc = $(this).attr("src");
    const offSrc = "/assets/favorite_off-b64fb282a5edea58b8218a4c042c0c34b2012a6de5b87ac26dd6a8cd6cbef69f.png";
    const onSrc = "/assets/favorite_on-761b352ecf0b84688d7de314431f8fcd9a1c8814522dcd92c40b26c7ce43efa3.png";

    if (currentSrc.endsWith(offSrc)) {
      $(this).attr("src", onSrc);
    } else {
      $(this).attr("src", offSrc);
    }
  });

  // ダッシュボード url変更
  let selects = document.querySelectorAll(".aggregateTarget_select");

  $("#stMGList_btn").on("click", function () {
    let values = [];
    selects.forEach(function (select) {
      values.push(select.value);
    });
    let queryString = "daily=" + values[0] + "&year=" + values[1] + "&month=" + values[2] + "&day=" + values[3];
    let currentUrl = window.location.href;
    let updatedUrl;

    let baseUrl = currentUrl.split("?")[0];

    updatedUrl = baseUrl + "?" + queryString;

    window.location.href = updatedUrl;
  });

  // 検索画面 ソートurl変更
  $("#search_sort").on("change", function () {
    let selectedValue = $("#search_sort").val();
    let currentUrl = window.location.href;
    let updatedUrl;

    if (currentUrl.includes("?search_sort=") || currentUrl.includes("&search_sort=")) {
      updatedUrl = currentUrl.replace(/(\?|&)search_sort=[^&]*/, "$1search_sort=" + selectedValue);
    } else {
      updatedUrl = currentUrl + (currentUrl.includes("?") ? "&" : "?") + "search_sort=" + selectedValue;
    }
    window.location.href = updatedUrl;
  });

  // 検索画面 スライダー（記事スライダー以外）
  const swiper = new Swiper(".swiper:not(.articles-swiper)", {
    preloadImages: false,
    loop: true,
    pagination: {
      el: ".swiper-pagination",
    },
  });

  // 記事スライダー（3つの記事をローテーション表示）
  const articlesSlider = document.querySelector(".articles-swiper");
  if (articlesSlider) {
    const articlesSwiper = new Swiper(".articles-swiper", {
      loop: true,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      pagination: {
        el: ".articles-pagination",
        clickable: false,
      },
      speed: 800,
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      allowTouchMove: false,
      simulateTouch: false,
    });
  }

  // 選択画面
  function changeColor(event) {
    $(event).css("color", "#000");
  }

  $("#start_hour").on("change", function () {
    let selectedText = $(this).find("option:selected").text();

    $(".search_startHour").text(selectedText).removeClass("is-placeholder");

    if ($("#start_minute").val() === null || $("#start_minute").val() === "") {
      $("#start_minute").val(0);
      $(".search_startMinute").text("00").removeClass("is-placeholder");
    }

    if ($("#end_hour").val() === null || $("#end_hour").val() === "" || parseInt(selectedText) >= parseInt($("#end_hour").val())) {
      if (selectedText.trim() === "23") {
        $("#end_hour").val(0);
        $(".search_endHour").text("0").removeClass("is-placeholder");
      } else {
        $("#end_hour").val(String(parseInt(selectedText) + 1));
        $(".search_endHour").text(String(parseInt(selectedText) + 1)).removeClass("is-placeholder");
      }
    }

    if ($("#end_minute").val() === null || $("#end_minute").val() === "") {
      $("#end_minute").val(0);
      $(".search_endMinute").text("00").removeClass("is-placeholder");
    }

    // ×ボタンを表示
    $("#time_clear").show();
  });

  $("#start_minute").on("change", function () {
    let selectedText = $(this).find("option:selected").text();
    $(".search_startMinute").text(selectedText).removeClass("is-placeholder");
    $("#time_clear").show();
  });

  $("#end_hour").on("change", function () {
    let selectedText = $(this).find("option:selected").text();
    $(".search_endHour").text(selectedText).removeClass("is-placeholder");
    $("#time_clear").show();
  });

  $("#end_minute").on("change", function () {
    let selectedText = $(this).find("option:selected").text();
    $(".search_endMinute").text(selectedText).removeClass("is-placeholder");
    $("#time_clear").show();
  });

  // 日付クリアボタン
  $(document).off("click", "#datepicker_clear").on("click", "#datepicker_clear", function (e) {
    e.preventDefault();
    e.stopPropagation();
    $("#datepicker").val("");
    $("#datepicker_clear").hide();
  });

  // 時間クリアボタン
  $(document).off("click", "#time_clear").on("click", "#time_clear", function (e) {
    e.preventDefault();
    e.stopPropagation();
    // 各セレクトを未選択状態にリセット
    $("#start_hour").val("");
    $("#start_minute").val("");
    $("#end_hour").val("");
    $("#end_minute").val("");
    // 表示を「--」に戻す
    $(".search_startHour").text("--").addClass("is-placeholder");
    $(".search_startMinute").text("--").addClass("is-placeholder");
    $(".search_endHour").text("--").addClass("is-placeholder");
    $(".search_endMinute").text("--").addClass("is-placeholder");
    // エラースタイルもクリア
    $(".input_errMessage-date").hide();
    // ×ボタンを非表示
    $("#time_clear").hide();
  });

  $("#start_width").on("change", function () {
    let selectedText = $(this).find("option:selected").text();
    let selectedValue = $(this).val();

    $(".search_startWidth").text(selectedText);
    changeColor(".search_startWidth");

    // 下限値が選択された時の処理
    if (selectedValue !== "min") {
      let endWidth = $("#end_width");
      let endWidthValue = endWidth.val();

      // 上限値が未選択か、下限値より小さい値が選択されている場合
      if (endWidthValue !== "max" && (endWidthValue === "" || parseInt(selectedValue) > parseInt(endWidthValue))) {
        // 下限値以上の最小の選択肢を選択
        let found = false;
        endWidth.find("option").each(function () {
          if (!found && $(this).val() !== "" && $(this).val() !== "max" && parseInt($(this).val()) >= parseInt(selectedValue)) {
            endWidth.val($(this).val());
            $(".search_endWidth").text($(this).text());
            changeColor(".search_endWidth");
            found = true;
          }
        });

        // 適切な値が見つからない場合は「上限なし」を選択
        if (!found) {
          endWidth.val("max");
          $(".search_endWidth").text("上限なし");
          changeColor(".search_endWidth");
        }
      }
    }
  });

  $("#end_width").on("change", function () {
    let selectedText = $(this).find("option:selected").text();
    let selectedValue = $(this).val();

    $(".search_endWidth").text(selectedText);
    changeColor(".search_endWidth");

    // 上限値が選択された時の処理
    if (selectedValue !== "max") {
      let startWidth = $("#start_width");
      let startWidthValue = startWidth.val();

      // 下限値が未選択か、上限値より大きい値が選択されている場合
      if (startWidthValue !== "min" && (startWidthValue === "" || parseInt(startWidthValue) > parseInt(selectedValue))) {
        // 上限値以下の最大の選択肢を選択
        let found = false;
        $(startWidth.find("option").get().reverse()).each(function () {
          if (!found && $(this).val() !== "" && $(this).val() !== "min" && parseInt($(this).val()) <= parseInt(selectedValue)) {
            startWidth.val($(this).val());
            $(".search_startWidth").text($(this).text());
            changeColor(".search_startWidth");
            found = true;
          }
        });

        // 適切な値が見つからない場合は「下限なし」を選択
        if (!found) {
          startWidth.val("min");
          $(".search_startWidth").text("下限なし");
          changeColor(".search_startWidth");
        }
      }
    }
  });

  $("#start_bamiri").on("change", function () {
    let selectedText = $(this).find("option:selected").text();
    let selectedValue = $(this).val();

    $(".search_startBamiri").text(selectedText);
    changeColor(".search_startBamiri");

    // 下限値が選択された時の処理
    if (selectedValue !== "min") {
      let endBamiri = $("#end_bamiri");
      let endBamiriValue = endBamiri.val();

      // 上限値が未選択か、下限値より小さい値が選択されている場合
      if (endBamiriValue !== "max" && (endBamiriValue === "" || parseFloat(selectedValue) > parseFloat(endBamiriValue))) {
        // 下限値以上の最小の選択肢を選択
        let found = false;
        endBamiri.find("option").each(function () {
          if (!found && $(this).val() !== "" && $(this).val() !== "max" && parseFloat($(this).val()) >= parseFloat(selectedValue)) {
            endBamiri.val($(this).val());
            $(".search_endBamiri").text($(this).text());
            changeColor(".search_endBamiri");
            found = true;
          }
        });

        // 適切な値が見つからない場合は「上限なし」を選択
        if (!found) {
          endBamiri.val("max");
          $(".search_endBamiri").text("上限なし");
          changeColor(".search_endBamiri");
        }
      }
    }
  });

  $("#end_bamiri").on("change", function () {
    let selectedText = $(this).find("option:selected").text();
    let selectedValue = $(this).val();

    $(".search_endBamiri").text(selectedText);
    changeColor(".search_endBamiri");

    // 上限値が選択された時の処理
    if (selectedValue !== "max") {
      let startBamiri = $("#start_bamiri");
      let startBamiriValue = startBamiri.val();

      // 下限値が未選択か、上限値より大きい値が選択されている場合
      if (startBamiriValue !== "min" && (startBamiriValue === "" || parseFloat(startBamiriValue) > parseFloat(selectedValue))) {
        // 上限値以下の最大の選択肢を選択
        let found = false;
        $(startBamiri.find("option").get().reverse()).each(function () {
          if (!found && $(this).val() !== "" && $(this).val() !== "min" && parseFloat($(this).val()) <= parseFloat(selectedValue)) {
            startBamiri.val($(this).val());
            $(".search_startBamiri").text($(this).text());
            changeColor(".search_startBamiri");
            found = true;
          }
        });

        // 適切な値が見つからない場合は「下限なし」を選択
        if (!found) {
          startBamiri.val("min");
          $(".search_startBamiri").text("下限なし");
          changeColor(".search_startBamiri");
        }
      }
    }
  });

  // 予約画面
  $("#start_year").on("change", function () {
    let selectedText = $(this).find("option:selected").text();

    $(".reservation_startYear").text(selectedText);
    changeColor(".reservation_startYear");
  });

  $("#start_month").on("change", function () {
    let selectedText = $(this).find("option:selected").text();

    $(".reservation_startMonth").text(selectedText);
    changeColor(".reservation_startMonth");
  });

  $("#start_date").on("change", function () {
    let selectedText = $(this).find("option:selected").text();

    $(".reservation_startDate").text(selectedText);
    changeColor(".reservation_startDate");
  });

  // メニュー
  $(".menu_trigger").on("click", function () {
    $(".menu_overlay").css("height", $(document).height() + "px");
    $("nav").addClass("open");
    $(".menu_overlay").addClass("open");
  });
  $(".menu_trigger_close").on("click", function () {
    $(this).removeClass("active");
    $("nav").removeClass("open");
    $(".menu_overlay").removeClass("open");
  });
  $(".menu_overlay").on("click", function () {
    if ($(this).hasClass("open")) {
      $(this).removeClass("open");
      $("nav").removeClass("open");
    }
  });

  // 同意ボタン
  const agreementCheckbox = $(".privacy_agreeInput");
  const agreementLabel = $(".privacy_agreeLabel");
  const submitButton = $(".register_button");

  agreementCheckbox.on("change", function () {
    submitButton.prop("disabled", !agreementCheckbox.prop("checked"));
  });

  // 利用規約
  $(".login_link-terms").on("click", function (e) {
    e.preventDefault();
    const termsType = $(this).data("terms");

    $("#termsContent").html($("#" + termsType).html());
    $(".login_modal").fadeIn();

    agreementCheckbox.prop("disabled", false);
    agreementLabel.css("opacity", "1");
  });

  $(".login_modalClose, .login_modal").on("click", function (e) {
    if ($(e.target).hasClass("login_modalClose") || $(e.target).hasClass("login_modal")) {
      $(".login_modal").fadeOut(300, function () {
        $("#termsContent").html("");
      });
    }
  });

  // footer下部固定
  function adjustWrapperHeight() {
    const headerHeight = $("header").length ? $("header").get(0).getBoundingClientRect().height : 0;
    const footerHeight = $("footer").length ? $("footer").get(0).getBoundingClientRect().height : 0;
    const viewportHeight = $(window).height();

    $(".wrapper").css("min-height", viewportHeight - headerHeight - footerHeight + "px");
  }

  adjustWrapperHeight();
  $(window).on("resize", adjustWrapperHeight);

  // スタジオ詳細クリック時の処理
  $(".detail_openBtn").on("click", function () {
    $(".detail_accordion").toggle();
    $(".detail_openBtnBox").toggle();
  });

  // オプションへのスクロール処理
  window.scrollToOptions = function () {
    const $optionSection = $(".detail_optionTitle");
    if ($optionSection.length) {
      $("html, body").animate(
        {
          scrollTop: $optionSection.offset().top - 20,
        },
        500,
        "swing"
      );
    }
  };

  $('.detail_checkbox[type="checkbox"]').on("change", function () {
    const isOptionChecked = $(this).is(":checked");
    if (isOptionChecked) {
      $(this).closest(".detail_option").css("background", "#FBE4ED");
    } else {
      $(this).closest(".detail_option").css("background", "#F8F8F8");
    }

    // 利用料金の計算
    if ($(".detail_fee").length > 0) {
      const hourlyFee = parseInt($(this).val(), 10);

      if (!calendarSlotData) {
        if (reservationCalendarData) calendarSlotData = reservationCalendarData.slot;
      }

      let slotMinutes = calendarSlotData ? calendarSlotData.slotMinutes : null;

      if (!slotMinutes) {
        slotMinutes = 30; // 予約枠が何分単位がわからないときはデフォルト30分とする
      }

      let durationMinutes = 0;

      const startVal = $("#calendar_start_time").val();
      const endVal = $("#calendar_end_time").val();
      let startMinute = (!isNaN(parseInt(startVal, 10))) ? parseInt(startVal, 10) * slotMinutes : null;
      let endMinute = (!isNaN(parseInt(endVal, 10))) ? parseInt(endVal, 10) * slotMinutes : null;

      if (startMinute === null || endMinute === null) {
        const bottomTimeText = $("#bottom_selected_time").text().trim();
        if (bottomTimeText && bottomTimeText.includes("-")) {
          const parts = bottomTimeText.split("-").map(s => s.trim());
          if (parts.length === 2) {
            const parseTime = (timeStr) => {
              const match = timeStr.match(/^(翌)?(\d{2}):(\d{2})$/);

              if (!match) return null;

              const isNextDay = !!match[1];

              let hour = Number(match[2]);
              const minute = Number(match[3]);

              if (isNextDay) {
                hour += 24;
              }

              return hour * 60 + minute;
            };

            startMinute = parseTime(parts[0]);
            endMinute = parseTime(parts[1]);
          }
        }
      }

      if (startMinute !== null && endMinute !== null) {
        if (startMinute >= endMinute) {
          endMinute += 24 * 60;
        }
        durationMinutes = endMinute - startMinute;
      }

      // 時間が選択されていない場合や不正値の場合は1時間として計算
      if (durationMinutes <= 0) {
        durationMinutes = 60;
      }

      const optionFee = Math.round(hourlyFee * durationMinutes / 60);

      $(".detail_fee").each(function() {
        const sumFeeTxt = $(this).text().replace("¥", "").replace(/,/g, "");
        if (sumFeeTxt !== "-" && !isNaN(parseInt(sumFeeTxt, 10))) {
          const sumFee = parseInt(sumFeeTxt, 10);
          const finalFee = isOptionChecked ? sumFee + optionFee : sumFee - optionFee;
          const updatedSumFeeTxt = "¥" + finalFee.toString(10).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
          $(this).text(updatedSumFeeTxt);
        }
      });
    }

    const selectedOu = $(this).attr("ou");

    // 予約URLの変更
    if ($(".detail_button-active").length > 0) {
      $(".detail_button-active").each(function() {
        const href = $(this).attr("href");

        const reserveUrl = new URL(href, window.location.origin);
        const params = reserveUrl.searchParams;

        if (isOptionChecked) {
          params.append("ou[]", selectedOu);
        } else {
          const allOus = params.getAll("ou[]");
          const filteredOus = allOus.filter(ou => ou !== selectedOu);

          params.delete("ou[]");

          filteredOus.forEach(ou => {
            params.append("ou[]", ou);
          });
        }

        const updatedUrl = `${reserveUrl.pathname}?${params.toString()}`;

        $(this).attr("href", updatedUrl);
      });
    }

    // 現在のページURLの変更
    // （予約ページ内から＜ボタンや×ボタンでルーム詳細に戻った際に日時やオプションの選択状態を維持しておきたいのと、
    //   予約前に日時とオプションを選択して料金確認後、LINE等でここどう？みたいな感じで選択状態ごと（料金ごと）グループにシェアするようなユースケースのために、URLに選択状態を保存しておく）
    const currentUrl = new URL(window.location.href);
    const params = currentUrl.searchParams;

    if (isOptionChecked) {
      params.append("ou[]", selectedOu);
    } else {
      const allOus = params.getAll("ou[]");
      const filteredOus = allOus.filter(ou => ou !== selectedOu);

      params.delete("ou[]");

      filteredOus.forEach(ou => {
        params.append("ou[]", ou);
      });
    }

    window.history.replaceState(
      history.state,
      "",
      currentUrl.toString()
    );
  });

  // 予約画面 表示非表示の処理
  $("#reservation_infoButton").on("click", function () {
    $("#reservation_info").hide();
    $("#reservation_user").show();
  });

  $("#reservation_userButton").on("click", function () {
    // 氏名（姓）のチェック（必須＋最大文字数）
    const lastName = $("#payerLastName").val().trim();
    if (lastName === "") {
      $("#payerLastName").addClass("reservation_err");
      $(".input_errMessage-lastName").show().text("※入力してください");
    } else if (lastName.length > 10) {
      $("#payerLastName").addClass("reservation_err");
      $(".input_errMessage-lastName").show().text("※10文字以内で入力してください");
    } else {
      $("#payerLastName").removeClass("reservation_err");
      $(".input_errMessage-lastName").hide();
    }

    // 氏名（名）のチェック（必須＋最大文字数）
    const firstName = $("#payerFirstName").val().trim();
    if (firstName === "") {
      $("#payerFirstName").addClass("reservation_err");
      $(".input_errMessage-firstName").show().text("※入力してください");
    } else if (firstName.length > 10) {
      $("#payerFirstName").addClass("reservation_err");
      $(".input_errMessage-firstName").show().text("※10文字以内で入力してください");
    } else {
      $("#payerFirstName").removeClass("reservation_err");
      $(".input_errMessage-firstName").hide();
    }

    let kanaPattern = /^[\u30a1-\u30f6\s]+$/;

    // 氏名カナ（姓）のチェック（必須＋最大文字数）
    const lastNameKana = $("#payerLastNameKana").val().trim();
    if (lastNameKana === "") {
      $("#payerLastNameKana").addClass("reservation_err");
      $(".input_errMessage-lastNameKana").show().text("※入力してください");
    } else if (!kanaPattern.test(lastNameKana)) {
      $("#payerLastNameKana").addClass("reservation_err");
      $(".input_errMessage-lastNameKana").show().text("※カタカナで入力してください");
    } else if (lastNameKana.length > 10) {
      $("#payerLastNameKana").addClass("reservation_err");
      $(".input_errMessage-lastNameKana").show().text("※10文字以内で入力してください");
    } else {
      $("#payerLastNameKana").removeClass("reservation_err");
      $(".input_errMessage-lastNameKana").hide();
    }

    // 氏名カナ（名）のチェック（必須＋最大文字数）
    const firstNameKana = $("#payerFirstNameKana").val().trim();
    if (firstNameKana === "") {
      $("#payerFirstNameKana").addClass("reservation_err");
      $(".input_errMessage-firstNameKana").show().text("※入力してください");
    } else if (!kanaPattern.test(firstNameKana)) {
      $("#payerFirstNameKana").addClass("reservation_err");
      $(".input_errMessage-firstNameKana").show().text("※カタカナで入力してください");
    } else if (firstNameKana.length > 10) {
      $("#payerFirstNameKana").addClass("reservation_err");
      $(".input_errMessage-firstNameKana").show().text("※10文字以内で入力してください");
    } else {
      $("#payerFirstNameKana").removeClass("reservation_err");
      $(".input_errMessage-firstNameKana").hide();
    }

    // 都道府県のチェック（必須＋最大文字数）
    const prefecture = $("#prefecture").val();
    if (prefecture === "" || prefecture === null) {
      $("#prefecture").addClass("reservation_err");
      $(".input_errMessage-prefecture").show().text("※選択してください");
    } else if (prefecture.length > 25) {
      $("#prefecture").addClass("reservation_err");
      $(".input_errMessage-prefecture").show().text("※25文字以内で入力してください");
    } else {
      $("#prefecture").removeClass("reservation_err");
      $(".input_errMessage-prefecture").hide();
    }

    // 市区町村、番地のチェック（必須＋最大文字数）
    const city = $("#city").val().trim();
    if (city === "") {
      $("#city").addClass("reservation_err");
      $(".input_errMessage-city").show().text("※入力してください");
    } else if (city.length > 50) {
      $("#city").addClass("reservation_err");
      $(".input_errMessage-city").show().text("※50文字以内で入力してください");
    } else {
      $("#city").removeClass("reservation_err");
      $(".input_errMessage-city").hide();
    }

    // マンション・ビルのチェック（最大文字数のみ）
    const building = $("#building").val().trim();
    if (building.length > 50) {
      $("#building").addClass("reservation_err");
      $(".input_errMessage-building").show().text("※50文字以内で入力してください");
    } else {
      $("#building").removeClass("reservation_err");
      $(".input_errMessage-building").hide();
    }

    // 入力された電話番号を取得
    let phoneNumber = $("#tel").val().replace(/-/g, "");
    let phonePattern = /^\d{10,11}$/;

    // 電話番号のチェック
    if (phoneNumber === "") {
      $("#tel").addClass("reservation_err");
      $(".input_errMessage-telNum").show().text("※入力してください");
    } else if (!phonePattern.test(phoneNumber)) {
      $("#tel").addClass("reservation_err");
      $(".input_errMessage-telNum").show().text("※正しい電話番号を入力してください");
    } else {
      $("#tel").removeClass("reservation_err");
      $(".input_errMessage-telNum").hide();
    }

    // 生年月日のチェック
    let birthYear = $("#start_year option:selected").val();
    let birthMonth = $("#start_month option:selected").val();
    let birthDay = $("#start_date option:selected").val();

    if (!birthYear || !birthMonth || !birthDay) {
      $(".input_errMessage-birthdate").show().text("※入力してください");
      if (!birthYear) $(".reservation_startYear").addClass("reservation_err");
      if (!birthMonth) $(".reservation_startMonth").addClass("reservation_err");
      if (!birthDay) $(".reservation_startDate").addClass("reservation_err");
    } else {
      $(".input_errMessage-birthdate").hide();
      $(".reservation_startYear, .reservation_startMonth, .reservation_startDate").removeClass("reservation_err");
    }

    // 問題がなければ利用用途に進む
    if (!$(".input_errMessage").is(":visible")) {
      $("#reservation_user").hide();
      $("#reservation_usage").show();
    }
  });

  $("#reservation_usageButton").on("click", function () {
    if ($('.reservation_checkbox input[type="checkbox"]:checked').length > 0) {
      $(".input_errMessage-title").hide();
    } else {
      $(".input_errMessage-title").show();
    }

    if ($(".reservation_countSelect").val()) {
      $(".input_errMessage-count").hide();
    } else {
      $(".input_errMessage-count").show();
    }

    if ($(".reservation_genreSelect").val()) {
      $(".input_errMessage-genre").hide();
    } else {
      $(".input_errMessage-genre").show();
    }

    if (!$(".input_errMessage").is(":visible")) {
      $("#reservation_usage").hide();
      $("#reservation_payment").show();
    }
  });

  $("#reservationBtn_AllowBackInfo").on("click", function () {
    $("#reservation_user").hide();
    $("#reservation_info").show();
  });

  $("#reservationBtn_AllowBackUser").on("click", function () {
    $("#reservation_usage").hide();
    $("#reservation_user").show();
  });

  $("#reservationBtn_AllowBackUsage").on("click", function () {
    $("#reservation_payment").hide();
    $("#reservation_usage").show();
  });

  // バツボタン,予約情報確認画面の戻るボタンを押した時にブラウザバック
  $("#reservationBtn_AllowBack, #reservationBtn_closeImg").on("click", function () {
    window.history.back();
  });

  // 一部ポイント使用 表示非表示の処理
  $("input[name=use_point_type]").on("change", function () {
    if ($(this).val() == "partial") {
      $(".select_points").show("fast");
    } else {
      $(".select_points").hide("fast");
      $(".input_errMessage-point").hide();
    }
  });

  if ($("input[name=use_point_type]:checked").val() === "partial") {
    $(".select_points").show();
  } else {
    $(".select_points").hide();
  }

  $("input[name=usePoints]").on("input", function () {
    const val = $(this).val();
    if (!/^\d*$/.test(val)) {
      $(this).val(val.replace(/\D/g, ""));
    }
  });

  // --- 予約詳細の金額表示（ポイント利用時のストライクスルー＆割引後金額表示） ---
  function updateReservationDetailPrice() {
    var totalFee = parseInt($(".reservation_detailText-original").text().replace(/[^\d]/g, ""), 10);
    var usePointType = $("input[name=use_point_type]:checked").val();
    var hasPoints = parseInt($(".reservation_pointsSubTitle .fontSizeBig").text().replace(/[^\d]/g, ""), 10) || 0;
    var usePoints = 0;
    if (usePointType === "all") {
      usePoints = Math.min(hasPoints, totalFee);
    } else if (usePointType === "partial") {
      var partial = parseInt($("input[name=partial_use_points]").val(), 10);
      if (!isNaN(partial)) {
        usePoints = Math.min(partial, hasPoints, totalFee);
      }
    }
    // ポイントを利用しない場合は0に
    if (usePointType === "nothing" || !usePointType) {
      usePoints = 0;
      $("input[name=partial_use_points]").val("");
    }
    var discounted = totalFee - usePoints;
    $(".reservation_detailText-point").text(`ポイント利用： -¥${usePoints.toLocaleString()}`);
    $(".reservation_detailText-total").text(`ご請求額： ¥${discounted.toLocaleString()}`);
    $(".reservation_detailText-getpoint-value").text(`${Math.floor(discounted / 100).toLocaleString()}pt`);
  }

  // 初期表示
  updateReservationDetailPrice();
  // ポイント利用方法の変更
  $("input[name=use_point_type]").on("change", updateReservationDetailPrice);
  // 一部ポイント利用の入力
  $("input[name=partial_use_points]").on("input", function () {
    // 数字以外を除去
    var val = $(this).val();
    var digits = val.replace(/\D/g, "");
    if (val !== digits) {
      $(this).val(digits);
    }
    updateReservationDetailPrice();
  });

  // 一部ポイント利用の上限制御（blur時）
  $("input[name=partial_use_points]").on("blur", function () {
    var usePointType = $("input[name=use_point_type]:checked").val();
    if (usePointType !== "partial") return;
    var hasPoints = parseInt($(".reservation_pointsSubTitle .fontSizeBig").text().replace(/[^\d]/g, ""), 10) || 0;
    var val = parseInt($(this).val(), 10);
    if (!isNaN(val) && val > hasPoints) {
      $(this).val(hasPoints);
      updateReservationDetailPrice();
    }
  });

  // 支払い方法選択 表示非表示の処理
  $(".reservation_paymentInput[name=payment_type]").on("click", function () {
    const paymentMethod = $(this).val();
    $(".select_card, .select_konbini, .select_paypay, .select_transfer, .select_onSite").hide("fast");

    if ($(this).hasClass("checked")) {
      $(this).prop("checked", false).data("clicked", false);
      $(this).removeClass("checked");
    } else {
      $(".reservation_paymentInput[name=payment_type]").data("clicked", false);
      $(this).data("clicked", true);
      $(".reservation_paymentInput[name=payment_type]").removeClass("checked");
      $(this).addClass("checked");

      switch (paymentMethod) {
        case "credit":
          $(".select_card").show("fast");
          break;
        case "paypay":
          $(".select_paypay").show("fast");
          break;
        case "konbini":
          $(".select_konbini").show("fast");
          break;
        case "on_site":
          $(".select_onSite").show("fast");
          break;
      }
    }
    
    // キャンセル通知の表示制御
    toggleCancellationNotice();
  });

  const paymentMethod = $(".reservation_paymentInput[name=payment_type]:checked").val();
  switch (paymentMethod) {
    case "credit":
      $(".select_card").show();
      break;
    case "paypay":
      $(".select_paypay").show();
      break;
    case "konbini":
      $(".select_konbini").show();
      break;
    case "on_site":
      $(".select_onSite").show();
      break;
  }

  // 4桁ごとに空白を入れる
  $("#cardno").on("input", function () {
    let value = $(this).val().replace(/\D/g, "");
    if (value.match(/.{1,4}/g)) {
      value = value.match(/.{1,4}/g).join(" ");
    } else {
      value = "";
    }
    $(this).val(value);
  });

  // 有効期限入力時に「/」を自動追加
  $("#expire").on("input", function () {
    let value = $(this).val().replace(/\D/g, "");
    if (value.length > 2) {
      value = value.substring(0, 2) + "/" + value.substring(2, 4);
    }
    $(this).val(value);
  });

  // クレジットカード決済用各種トークン取得
  $("#reservation_paymentButton").on("click", function (e) {
    let errFlg = false;
    let creditFlg = false;

    // 支払い選択 エラー判別
    if ($("input[name=payment_type]:checked").val()) {
      $(".input_errMessage-payment").hide();
    } else {
      $(".input_errMessage-payment").show();
      errFlg = true;
    }

    // ポイント入力 エラー判別
    if ($("input[name=use_point_type]:checked").val() === "partial") {
      const usePoints = $("input[name=partial_use_points]").val();
      if (/^\d+$/.test(usePoints)) {
        $(".input_errMessage-point").hide();
      } else {
        $(".input_errMessage-point").show();
        errFlg = true;
      }
    }

    // コンビニ支払い エラー判別
    if ($("input[name=payment_type]:checked").val() === "konbini") {
      if ($("input[name=konbini_code]:checked").length !== 0) {
        $(".input_errMessage-konbini").hide();
      } else {
        $(".input_errMessage-konbini").show();
        errFlg = true;
      }
    } else {
      $(".input_errMessage-konbini").hide();
    }

    // クレジットカード エラー判別
    if ($("input[name=payment_type]:checked").val() === "credit") {
      creditFlg = true;
      let isValid = true;
      $(".reservation_input-card").each(function () {
        if ($(this).val().trim() === "") {
          isValid = false;
        }
      });

      if (isValid) {
        $(".input_errMessage-card").hide();
      } else {
        $(".input_errMessage-card").show();
        errFlg = true;
      }
    } else {
      $(".input_errMessage-card").hide();
    }

    if (errFlg) {
      e.preventDefault();
      $("html, body").animate(
        {
          scrollTop: 0,
        },
        "fast",
        function () {
          setTimeout(() => {
            $("#reservation_paymentButton").prop('disabled', false);
          }, 1000);
        }
      );
      return;
    }

    if (creditFlg) {
      generateTokens();
    } else {
      $("#reservation_form")[0].requestSubmit();
    }
  });

  // 支払い方法が選択されていない場合や、コンビニ支払いが利用不可の場合は予約確定ボタンをdisabledにする
  function toggleReservationPaymentButton() {
    const paymentMethod = $(".reservation_paymentInput[name=payment_type]:checked").val();
    if (!paymentMethod) {
      $("#reservation_paymentButton").prop("disabled", true);
      return;
    }
    if (paymentMethod === "konbini" && typeof window.availableKonbini !== "undefined" && !window.availableKonbini) {
      $("#reservation_paymentButton").prop("disabled", true);
    } else {
      $("#reservation_paymentButton").prop("disabled", false);
    }
  }

  // キャンセル通知の表示制御
  function toggleCancellationNotice() {
    const $notice = $("#reservation_cancellationNotice");
    const $detail = $("#cancellationNoticeDetail");
    if (!$notice.length || !$detail.length) return;

    const paymentMethod = $(".reservation_paymentInput[name=payment_type]:checked").val();
    const isCreditSelected = paymentMethod === "credit";
    const isPayPaySelected = paymentMethod === "paypay";

    let shouldShowNotice = false;
    let noticeText = "";

    if (typeof window.reserveStartTime !== "undefined" && window.reserveStartTime) {
      const reserveDate = new Date(window.reserveStartTime);
      const currentDate = new Date();
      
      // クレジットカード: 6ヶ月以上先の場合（予約日当日から起算）
      if (isCreditSelected) {
        const sixMonthsFromNow = new Date();
        sixMonthsFromNow.setMonth(currentDate.getMonth() + 6);
        sixMonthsFromNow.setDate(sixMonthsFromNow.getDate() - 1);
        sixMonthsFromNow.setHours(23, 59, 59, 999);
        
        if (reserveDate > sixMonthsFromNow) {
          shouldShowNotice = true;
          noticeText = "※クレジットカードでお支払いされた予約の、予約実行日から6ヶ月経過後のキャンセル時の返金は、振込み返金となります。キャンセル実行時、該当のお客様には別途ご案内メールをお送りします。<br>※予約実行日とは、お客さまが予約確定ボタン/予約リクエストボタンを押下し、その情報が弊社サーバに届き処理を開始したタイミングの日付となります。";
        }
      }

      // PayPay: 365日以上先の場合（予約日翌日から起算）
      if (isPayPaySelected) {
        const oneYearFromNow = new Date();
        oneYearFromNow.setDate(currentDate.getDate() + 365);
        oneYearFromNow.setHours(23, 59, 59, 999);
        
        if (reserveDate > oneYearFromNow) {
          shouldShowNotice = true;
          noticeText = "※PayPayでお支払いされた予約の、予約実行日翌日から365日経過後のキャンセル時の返金は、振込み返金となります。キャンセル実行時、該当のお客様には別途ご案内メールをお送りします。<br>※予約実行日とは、お客さまが予約確定ボタン/予約リクエストボタンを押下し、その情報が弊社サーバに届き処理を開始したタイミングの日付となります。";
        }
      }
    }
    
    if (shouldShowNotice) {
      $detail.html(noticeText);
      $notice.show();
    } else {
      $notice.hide();
    }
  }

  // 初期状態
  toggleReservationPaymentButton();
  toggleCancellationNotice();
  // 支払い方法選択時に状態を更新
  $(document).on("change", "input[name=payment_type]", function() {
    toggleReservationPaymentButton();
    toggleCancellationNotice();
  });
  $(document).on("click", "input[name=payment_type]", function () {
    setTimeout(function() {
      toggleReservationPaymentButton();
      toggleCancellationNotice();
    }, 0);
  });

  // ワンタイムトークン生成ロジック呼び出し
  function generateToken() {
    return new Promise((resolve) => {
      com_sbps_system.generateToken(
        {
          merchantId: process.env.PAYMENT_MERCHANT_ID,
          serviceId: process.env.PAYMENT_SERVICE_ID,
          ccNumber: $("#cardno").val().replaceAll(" ", ""),
          ccExpiration: $("#expire").val().split("/").reverse().join("").padStart(6, "20"),
          securityCode: $("#securitycode").val(),
        },
        (response) => {
          if (response.result == "OK") {
            // 予め購入フォームに用意したtokenフィールドに値を設定
            $("#token").val(response.tokenResponse.token);
            $("#token_key").val(response.tokenResponse.tokenKey);
          } else {
            // トークン取得に失敗したので空にして送信
            $("#token").val(null);
            $("#token_key").val(null);
          }

          // カード情報を送信しないようにフィールドの値を初期化
          $("#cardno").val(null);
          $("#expire").val(null);
          $("#securitycode").val(null);

          resolve();
        }
      );
    });
  }

  // カード利用者決済情報トークン生成ロジック呼び出し
  function generateTds2Token() {
    let holdername = $("#holdername").val().split(" ");
    let address1 = $("#prefecture").val();
    let address2 = $("#city").val();
    let address3 = $("#building").val();
    let tel = $("#tel").val();
    let email = $("#email").val();

    // 都道府県、市区町村、それ以降に分ける正規表現(参考：https://qiita.com/zakuroishikuro/items/066421bce820e3c73ce9)
    let r =
      /(...??[都道府県])((?:旭川|伊達|石狩|盛岡|奥州|田村|南相馬|那須塩原|東村山|武蔵村山|羽村|十日町|上越|富山|野々市|大町|蒲郡|四日市|姫路|大和郡山|廿日市|下松|岩国|田川|大村)市|.+?郡(?:玉村|大町|.+?)[町村]|.+?市.+?区|.+?[市区町村])(.+)/;
    let result = (address1 + address2).match(r);

    return new Promise((resolve) => {
      let payerAddress1 = address1 != null ? address1 : "";
      let payerAddress2_1 = result != null && result[2] != null ? result[2] : "";
      let payerAddress2_2 = result != null && result[3] != null ? result[3] : "";
      let payerAddress3 = address3 != null ? address3 : "";

      com_sbps_system_tds2.generateToken(
        {
          merchantId: process.env.PAYMENT_MERCHANT_ID,
          serviceId: process.env.PAYMENT_SERVICE_ID,
          billingLastName: holdername[1] != null ? holdername[1] : "",
          billingFirstName: holdername[0] != null ? holdername[0] : "",
          billingPostalCode: "",
          billingCity: payerAddress1,
          billingAddress1: payerAddress2_1,
          billingAddress2: payerAddress2_2,
          billingAddress3: payerAddress3,
          billingPhone: tel != null ? tel : "",
          workPhone: "",
          shippingPostalCode: "",
          shippingCity: payerAddress1,
          shippingAddress1: payerAddress2_1,
          shippingAddress2: payerAddress2_2,
          shippingAddress3: payerAddress3,
          email: email != null ? email : "",
        },
        (response) => {
          if (response.result == "OK") {
            // 予め購入フォームに用意したtokenフィールドに値を設定
            $("#tds2_info_token").val(response.tokenResponse.tds2infoToken);
            $("#tds2_info_token_key").val(response.tokenResponse.tds2infoTokenKey);
          } else {
            // トークン取得に失敗したので空にして送信
            $("#tds2_info_token").val(null);
            $("#tds2_info_token_key").val(null);
          }

          // カード情報を送信しないようにフィールドの値を初期化
          $("#holdername").val(null);

          resolve();
        }
      );
    });
  }

  // ブラウザの互換性を考えて、あえてasync/awaitを使わず純粋なPromiseのみで書いています
  function generateTokens() {
    const gToken = generateToken();
    const gTds2Token = generateTds2Token();
    Promise.all([gToken, gTds2Token]).then(() => {
      // 2種類のトークン生成が完了したら、フォームをsubmitして購入処理を進める
      $("#reservation_form")[0].requestSubmit();
    });
  }

  // シェアボタンの実装
  $(document).on("click", ".reserved_shareImgBox-content", function () {
    if (!navigator.share) {
      return;
    }

    // コンテンツ取得 - より正確なセレクターを使用
    const studioName = $(".reserved_text").eq(0).find(".reserved_text-content").text().trim();
    const dateTime = $(".reserved_text").eq(1).find(".reserved_text-content").text().trim();
    const address = $(".reserved_text").eq(2).find(".reserved_text-content").text().trim();
    const roomDetailUrl = $(".reserved_text").eq(0).find(".reserved_text-content").data("detail-url");
    
    // アクセス情報を取得（複数ある場合も考慮）
    const accessItems = [];
    $(".reserved_text-access .reserved_text-content").each(function() {
      const accessText = $(this).text().trim();
      if (accessText) {
        accessItems.push(accessText);
      }
    });

    // テキストを設定
    let shareText = `\n${studioName}\n日時: ${dateTime}\n場所: ${address}`;
    if (accessItems.length > 0) {
      accessItems.forEach((access) => {
        shareText += `\nアクセス:${access}`;
      });
    }

    let shareUrl = roomDetailUrl;
    if (!shareUrl) {
      shareUrl = window.location.href;
    }

    navigator
      .share({
        title: "スタジオ予約完了",
        text: shareText,
        url: shareUrl,
      })
      .then(() => console.log("Successful share"))
      .catch((error) => console.log("Error sharing:", error));
  });

  document.addEventListener("DOMContentLoaded", function () {
    const shareButton = document.querySelector(".reserved_shareImgBox-content");
    if (shareButton && !navigator.share) {
      shareButton.classList.add("not-supported");
      shareButton.title = "お使いの環境ではシェア機能を利用できません";
    }
  });

  // --------スタジオ管理画面 --------
  // パスワード入力
  $(".togglePassword").on("click", function (e) {
    let passwordField = $("#password");
    let passwordFieldType = passwordField.attr("type");
    let icon = $(this).find("i");

    if (passwordFieldType === "password") {
      passwordField.attr("type", "text");
      icon.removeClass("fa-eye").addClass("fa-eye-slash");
    } else {
      passwordField.attr("type", "password");
      icon.removeClass("fa-eye-slash").addClass("fa-eye");
    }
  });

  // パスワード再入力
  $(".togglePasswordConfirmation").on("click", function (e) {
    let passwordField = $("#password_confirmation");
    let passwordFieldType = passwordField.attr("type");
    let icon = $(this).find("i");

    if (passwordFieldType === "password") {
      passwordField.attr("type", "text");
      icon.removeClass("fa-eye").addClass("fa-eye-slash");
    } else {
      passwordField.attr("type", "password");
      icon.removeClass("fa-eye-slash").addClass("fa-eye");
    }
  });

  // トースト
  setTimeout(() => {
    $(".flash_message").removeClass("show");
  }, 5000);

  // --------管理者サイドバーメニュー--------
  // 管理者メニュー 開く
  $(".adminMenu_trigger").on("click", function () {
    $(".adminMenu").addClass("open");
    $(".admin").css("margin-left", "280px");
  });

  // 管理者メニュー 閉じる
  $(".adminMenu_closeBtn").on("click", function () {
    $(".adminMenu").removeClass("open");
    $(".admin").css("margin-left", "0");
  });

  // メニューの初期状態をチェックして、開いている場合はヘッダーのスタイルも調整
  if ($(".stMenu").hasClass("open")) {
    $(".studioWrap").addClass("open");
    $(".footer_box").addClass("open");
    $(".stHeader").css("min-width", "1280px");
  }

  // メニュー
  $(".stMenu_trigger").on("click", function () {
    $(".studioWrap").addClass("open");
    $(".footer_box").addClass("open");
    $("nav").addClass("open");
    $(".stHeader").css("min-width", "1280px");
  });

  $(".stMenu_trigger_close").on("click", function () {
    $(".studioWrap").removeClass("open");
    $(".footer_box").removeClass("open");
    $("nav").removeClass("open");
    $(".stHeader").css("min-width", "954px");
  });

  // 基本情報 選択時
  var listItems = document.querySelectorAll(".stRoomEdit_ListItem");

  listItems.forEach(function (item) {
    // 親要素のlabel内のチェックボックスを取得
    var checkbox = item.closest("label").querySelector('input[type="checkbox"]');

    // チェックボックスの状態変化を監視
    checkbox.addEventListener("change", function () {
      if (this.checked) {
        item.classList.add("selected");
      } else {
        item.classList.remove("selected");
      }
    });
  });

  // 料金設定行のHTMLテンプレート
  var rateRowTemplate = '<tr class="stRoomEdit_rateRow"><td><div class="form_row w100"><div class="stRoomEdit_weekInput w100"><span class="stRoomEdit_weekLabel">曜日<img class="search_img" src="/assets/down-e8bf3054e87e306d8a948837be3e07b7ab3fef1b9d2742ae154a8466bf66999a.png"></span><input class="stRoomEdit_weekMenuBar" type="checkbox"><ul class="stRoomEdit_weekMenuWrapper" style="display: none;"><li class="stRoomEdit_weekMenu"><input type="checkbox" value="1"><span class="stRoomEdit_weeks">月曜日</span></li><li class="stRoomEdit_weekMenu"><input type="checkbox" value="2"><span class="stRoomEdit_weeks">火曜日</span></li><li class="stRoomEdit_weekMenu"><input type="checkbox" value="3"><span class="stRoomEdit_weeks">水曜日</span></li><li class="stRoomEdit_weekMenu"><input type="checkbox" value="4"><span class="stRoomEdit_weeks">木曜日</span></li><li class="stRoomEdit_weekMenu"><input type="checkbox" value="5"><span class="stRoomEdit_weeks">金曜日</span></li><li class="stRoomEdit_weekMenu"><input type="checkbox" value="6"><span class="stRoomEdit_weeks">土曜日</span></li><li class="stRoomEdit_weekMenu"><input type="checkbox" value="0"><span class="stRoomEdit_weeks">日曜日</span></li><li class="stRoomEdit_weekMenu"><input type="checkbox" value="7"><span class="stRoomEdit_weeks">祝日</span></li><input type="hidden" name="room[plans][][plan_fees][][weekday_mask]" class="stRoomEdit_rateRowWeekdayMask"></ul></div></div></td><td><div class="form_row"><label class="select_time_input"><select class="start_hour search_input search_inputTime search_inputForm" name="room[plans][][plan_fees][][start_hour]"><option value="" disabled="" selected="" hidden="">時</option><option value="0">0</option><option value="1">1</option><option value="2">2</option><option value="3">3</option><option value="4">4</option><option value="5">5</option><option value="6">6</option><option value="7">7</option><option value="8">8</option><option value="9">9</option><option value="10">10</option><option value="11">11</option><option value="12">12</option><option value="13">13</option><option value="14">14</option><option value="15">15</option><option value="16">16</option><option value="17">17</option><option value="18">18</option><option value="19">19</option><option value="20">20</option><option value="21">21</option><option value="22">22</option><option value="23">23</option></select><div class="search_divSelect search_startHour">時</div><div class="search_imgContainer"><img class="search_img" src="/assets/down-e8bf3054e87e306d8a948837be3e07b7ab3fef1b9d2742ae154a8466bf66999a.png"></div></label><div class="search_timeSpace">:</div><label class="select_time_input"><select class="start_minute search_input search_inputTime search_inputForm" name="room[plans][][plan_fees][][start_minute]"><option value="" disabled="" selected="" hidden="">分</option><option value="0">00</option><option value="15">15</option><option value="30">30</option><option value="45">45</option></select><div class="search_divSelect search_startMinute">分</div><div class="search_imgContainer"><img class="search_img" src="/assets/down-e8bf3054e87e306d8a948837be3e07b7ab3fef1b9d2742ae154a8466bf66999a.png"></div></label></div></td><td><div class="form_row"><label class="select_time_input"><select class="end_hour search_input search_inputTime search_inputForm" name="room[plans][][plan_fees][][end_hour]"><option value="" disabled="" selected="" hidden="">時</option><option value="0">0</option><option value="1">1</option><option value="2">2</option><option value="3">3</option><option value="4">4</option><option value="5">5</option><option value="6">6</option><option value="7">7</option><option value="8">8</option><option value="9">9</option><option value="10">10</option><option value="11">11</option><option value="12">12</option><option value="13">13</option><option value="14">14</option><option value="15">15</option><option value="16">16</option><option value="17">17</option><option value="18">18</option><option value="19">19</option><option value="20">20</option><option value="21">21</option><option value="22">22</option><option value="23">23</option><option value="24">24</option><option value="25">25</option><option value="26">26</option><option value="27">27</option><option value="28">28</option><option value="29">29</option></select><div class="search_divSelect search_endHour">時</div><div class="search_imgContainer"><img class="search_img" src="/assets/down-e8bf3054e87e306d8a948837be3e07b7ab3fef1b9d2742ae154a8466bf66999a.png"></div></label><div class="search_timeSpace">:</div><label class="select_time_input"><select class="end_minute search_input search_inputTime search_inputForm" name="room[plans][][plan_fees][][end_minute]"><option value="" disabled="" selected="" hidden="">分</option><option value="0">00</option><option value="15">15</option><option value="30">30</option><option value="45">45</option></select><div class="search_divSelect search_endMinute">分</div><div class="search_imgContainer"><img class="search_img" src="/assets/down-e8bf3054e87e306d8a948837be3e07b7ab3fef1b9d2742ae154a8466bf66999a.png"></div></label></div></td><td><input type="text" name="room[plans][][plan_fees][][fee]" class="stRoomEdit_tableInput stRoomEdit_tableInputPrice" value="" placeholder="例）2000">円</td><td class="tblBtnTd stRoomEdit_tableBtnTd"><button class="tblBtn stRoomEdit_tableBtn removeBtnRate" type="button">ー</button></td></tr>';

  // プラン2つ以上の場合、プランを追加ボタンを表示
  function toggleBottomAddPlanButton() {
    if ($(".stRoomEdit_planBlock").length >= 2) {
      $(".stRoomEdit_addBtn-plan-bottom").show();
    } else {
      $(".stRoomEdit_addBtn-plan-bottom").hide();
    }
  }

  toggleBottomAddPlanButton();

  // プラン設定枠を追加する
  $(".stRoomEdit_addBtn-plan").on("click", function (e) {
    var planBlockHtml = '<div class="stRoomEdit_planBlock">' +
      '<div class="stRoomEdit_planBlock_header">' +
        '<div class="stRoomEdit_planBlock_field">' +
          '<p class="stRoomEdit_planBlock_label">プラン名</p>' +
          '<span class="input_errMessage input_errMessage-planName">※80文字以内で入力してください。</span>' +
          '<input type="text" class="stRoomEdit_planBlockName stRoomEdit_input" name="room[plans][][name]" value="" placeholder="例）平日昼間プラン">' +
        '</div>' +
        '<div class="stRoomEdit_planBlock_field">' +
          '<p class="stRoomEdit_planBlock_label">最低利用時間</p>' +
          '<div class="stRoomEdit_planBlock_minTimeInputs">' +
            '<input type="text" class="stRoomEdit_planBlockMinHour stRoomEdit_tableInput stRoomEdit_tableInputTime" name="room[plans][][min_rental_time_hour]" value="" placeholder="例）1">' +
            '<span class="stRoomEdit_planBlock_unit">時間</span>' +
            '<input type="text" class="stRoomEdit_planBlockMinMinute stRoomEdit_tableInput stRoomEdit_tableInputTime" name="room[plans][][min_rental_time_minute]" value="" placeholder="00">' +
            '<span class="stRoomEdit_planBlock_unit">分</span>' +
          '</div>' +
        '</div>' +
      '</div>' +
      '<div class="stRoomEdit_rateSection">' +
        '<div class="button stRoomEdit_addBtn stRoomEdit_addBtn-rate">料金設定枠を追加する</div>' +
        '<table class="stRoomEdit_rateTable">' +
          '<tr><th>曜日</th><th>開始時刻</th><th>終了時刻</th><th>1時間あたりの料金（税込）</th></tr>' +
          rateRowTemplate.replace('<button class="tblBtn stRoomEdit_tableBtn removeBtnRate" type="button">ー</button>', '') +
        '</table>' +
      '</div>' +
      '<div class="stRoomEdit_planBlock_footer">' +
        '<button class="button stRoomEdit_removeBtnPlan" type="button">このプランを削除する</button>' +
      '</div>' +
    '</div>';
    $(".stRoomEdit_planContainer").append(planBlockHtml);

    // ボタン押下フィードバック
    var $btn = $(this);
    $btn.css({ "opacity": "0.5", "pointer-events": "none" });
    setTimeout(function () { $btn.css({ "opacity": "", "pointer-events": "" }); }, 300);

    // 追加されたプラン枠にスクロール＋ハイライト
    var $newBlock = $(".stRoomEdit_planContainer .stRoomEdit_planBlock:last");
    $("html, body").animate({
      scrollTop: $newBlock.offset().top - 100
    }, 400);
    $newBlock.addClass("stRoomEdit_planBlock--highlight");
    setTimeout(function () {
      $newBlock.removeClass("stRoomEdit_planBlock--highlight");
    }, 1500);

    toggleBottomAddPlanButton();
  });

  // 料金設定枠を追加する
  $(".stRoomEdit_mainDetail").on("click", ".stRoomEdit_addBtn-rate", function () {
    // ボタン押下フィードバック
    var $btn = $(this);
    $btn.css({ "opacity": "0.5", "pointer-events": "none" });
    setTimeout(function () { $btn.css({ "opacity": "", "pointer-events": "" }); }, 300);

    $(this).closest(".stRoomEdit_rateSection").find(".stRoomEdit_rateTable").append(rateRowTemplate);
  });

  // 料金設定行を削除する
  $(".stRoomEdit_mainDetail").on("click", ".removeBtnRate", function () {
    $(this).closest("tr").remove();
  });

  // プラン設定枠全体を削除する
  $(".stRoomEdit_mainDetail").on("click", ".stRoomEdit_removeBtnPlan", function () {
    $(this).closest(".stRoomEdit_planBlock").remove();
    toggleBottomAddPlanButton();
  });

  $(".stRoomEdit_addBtn-option").on("click", function (e) {
    // オプション追加・削除
    if ($(".stRoomEdit_optionTbl").is(":hidden") && $(".stRoomEdit_optionTbl tr").length === 2) {
      $(".stRoomEdit_optionTbl").show();
      return;
    }

    if ($(".stRoomEdit_optionTbl").is(":hidden") && $(".stRoomEdit_optionTbl tr").length === 1) {
      $(".stRoomEdit_optionTbl").show();
    }

    $(".stRoomEdit_optionTbl").append(
      '<tr><td class="stRoomEdit_optionInputBox"><span class="input_errMessage input_errMessage-optionName">※80文字以内で入力してください。</span><input class="stRoomEdit_optionInput" type="text" name="room[options][][name]" value="" placeholder="例）オプション名"></td><td><div class="stRoomEdit_optionPriceBox"><label class="pulldown_label"><select class="pulldown_select stRoomEdit_select stRoomEdit_selectOption" name="room[options][][free_or_paid]"><option value="free" selected="">無料で貸し出す</option><option value="paid">有料で貸し出す</option></select><div class="pulldown_divSelect pulldown_option">無料で貸し出す</div><div class="pulldown_imgContainer"><img class="pulldown_img" src="/assets/down-e8bf3054e87e306d8a948837be3e07b7ab3fef1b9d2742ae154a8466bf66999a.png"></div></label><div class="stRoomEdit_optionPriceWrapper"><input class="stRoomEdit_optionPrice" type="text" name="room[options][][hourly_fee]" placeholder="例）1500">円/個（1時間あたり）</div><input type="hidden" name="room[options][][order_required]" value="0" autocomplete="off"><label><input class="stRoomEdit_optionOrder" type="checkbox" name="room[options][][order_required]" value="1">予約時注文制にする</label></div></td><td class="tblBtnTd stRoomEdit_tableBtnTd"><button class="tblBtn stRoomEdit_tableBtn removeBtnOption" type="button">ー</button></td></tr>'
    );
  });

  $(".stRoomEdit_addBtn-cancelStudio").on("click", function (e) {
    // キャンセルポリシー スタジオ向け枠追加
    $(".st_btnWrapper")
      .last()
      .after(
        '<div class="st_btnWrapper"><label class="st_selectLabel"><select name="studio[cancel_policies][][day]" class="st_select", id: nil><option selected="selected" value="0">当日</option><option value="1">前日</option><option value="2">2日前</option><option value="3">3日前</option><option value="4">4日前</option><option value="5">5日前</option><option value="6">6日前</option><option value="7">7日前</option><option value="8">8日前</option><option value="9">9日前</option><option value="10">10日前</option><option value="11">11日前</option><option value="12">12日前</option><option value="13">13日前</option><option value="14">14日前</option><option value="15">15日前</option><option value="16">16日前</option><option value="17">17日前</option><option value="18">18日前</option><option value="19">19日前</option><option value="20">20日前</option><option value="21">21日前</option><option value="22">22日前</option><option value="23">23日前</option><option value="24">24日前</option><option value="25">25日前</option><option value="26">26日前</option><option value="27">27日前</option><option value="28">28日前</option><option value="29">29日前</option><option value="30">30日前</option><option value="40">40日前</option><option value="50">50日前</option><option value="60">60日前</option><option value="70">70日前</option><option value="80">80日前</option><option value="90">90日前</option></select></label>から<label class="st_selectLabel"><select name="studio[cancel_policies][][percent]" class="st_select", id: nil><option selected="selected" value="100">100%</option><option value="95">95%</option><option value="90">90%</option><option value="85">85%</option><option value="80">80%</option><option value="75">75%</option><option value="70">70%</option><option value="65">65%</option><option value="60">60%</option><option value="55">55%</option><option value="50">50%</option><option value="45">45%</option><option value="40">40%</option><option value="35">35%</option><option value="30">30%</option><option value="25">25%</option><option value="20">20%</option><option value="15">15%</option><option value="10">10%</option><option value="5">5%</option><option value="0">0%</option></select></label><div class="stRoomEdit_tableBtn"><button class="removeBtnCancel" type="button">ー</button></div></div>'
      );
  });

  $(".stRoomEdit_addBtn-cancelRoom").on("click", function (e) {
    const cancel_policy =
      '<div class="st_btnWrapper"><label class="st_selectLabel"><select name="room[cancel_policies][][day]" class="st_select", id: nil><option selected="selected" value="0">当日</option><option value="1">前日</option><option value="2">2日前</option><option value="3">3日前</option><option value="4">4日前</option><option value="5">5日前</option><option value="6">6日前</option><option value="7">7日前</option><option value="8">8日前</option><option value="9">9日前</option><option value="10">10日前</option><option value="11">11日前</option><option value="12">12日前</option><option value="13">13日前</option><option value="14">14日前</option><option value="15">15日前</option><option value="16">16日前</option><option value="17">17日前</option><option value="18">18日前</option><option value="19">19日前</option><option value="20">20日前</option><option value="21">21日前</option><option value="22">22日前</option><option value="23">23日前</option><option value="24">24日前</option><option value="25">25日前</option><option value="26">26日前</option><option value="27">27日前</option><option value="28">28日前</option><option value="29">29日前</option><option value="30">30日前</option><option value="40">40日前</option><option value="50">50日前</option><option value="60">60日前</option><option value="70">70日前</option><option value="80">80日前</option><option value="90">90日前</option></select></label>から<label class="st_selectLabel"><select name="room[cancel_policies][][percent]" class="st_select", id: nil><option selected="selected" value="100">100%</option><option value="95">95%</option><option value="90">90%</option><option value="85">85%</option><option value="80">80%</option><option value="75">75%</option><option value="70">70%</option><option value="65">65%</option><option value="60">60%</option><option value="55">55%</option><option value="50">50%</option><option value="45">45%</option><option value="40">40%</option><option value="35">35%</option><option value="30">30%</option><option value="25">25%</option><option value="20">20%</option><option value="15">15%</option><option value="10">10%</option><option value="5">5%</option><option value="0">0%</option></select></label><div class="stRoomEdit_tableBtn"><button class="removeBtnCancel" type="button">ー</button></div></div>';

    // キャンセルポリシー ルーム向け枠追加
    if ($(".st_btnWrapper").length === 0) {
      $(".stRoomEdit_addBtn-cancelRoom").before(cancel_policy);
    } else {
      $(".st_btnWrapper").last().after(cancel_policy);
    }
  });

  $(".stRoomEdit_mainDetail").on("click", ".stRoomEdit_addBtnMail", function () {
    // 予約メール追加
    $(".stRoomEdit_addBtnMail").after(
      '<div class="mailWrapper"><span class="input_errMessage input_errMessage-inputSubject">※入力してください</span><input class=stRoomEdit_mailSubject id=subject name=room[subject_reserve] placeholder=件名><span class="input_errMessage input_errMessage-inputMessage">※入力してください</span><textarea class=stRoomEdit_mailMessage id=message name=room[message_reserve] placeholder=本文 rows=20></textarea><div class="button stRoomEdit_cancelBtnMail">メールの設定を削除する</div></div>'
    );

    $(".stRoomEdit_addBtnMail").remove();
  });

  $(".stRoomEdit_mainDetail").on("click", ".stRoomEdit_cancelBtnMail", function () {
    $(".mailWrapper").remove();
    $(".mailSetting").after('<div class="button stRoomEdit_addBtn stRoomEdit_addBtnMail">メールを設定する</div>');
  });

  $(document).on("change", ".start_hour", function () {
    let selectedText = $(this).find("option:selected").text();

    $(this).next().text(selectedText);
    changeColor($(this).next());
  });

  $(document).on("change", ".start_minute", function () {
    let selectedText = $(this).find("option:selected").text();

    $(this).next().text(selectedText);
    changeColor($(this).next());
  });

  $(document).on("change", ".end_hour", function () {
    let selectedText = $(this).find("option:selected").text();

    $(this).next().text(selectedText);
    changeColor($(this).next());
  });

  $(document).on("change", ".end_minute", function () {
    let selectedText = $(this).find("option:selected").text();

    $(this).next().text(selectedText);
    changeColor($(this).next());
  });

  // バミリ
  $(document).on("change", ".stRoomEdit_selectBamiri", function () {
    let selectedText = $(this).find("option:selected").text();
    $(this).next().text(selectedText);
  });

  // オプション欄
  $(document).on("change", ".stRoomEdit_selectOption", function () {
    let selectedText = $(this).find("option:selected").text();
    $(this).next().text(selectedText);

    if ($(this).val() === "paid") {
      $(this).parent().next().show();
    } else {
      $(this).parent().next().hide();
    }
  });

  $(document).on("click", ".removeBtnOption", function () {
    $(this).closest("tr").remove();

    if ($(".stRoomEdit_optionTbl tr").length === 1) {
      $(".stRoomEdit_optionTbl").hide();
    }
  });

  $(document).on("change", ".stRoomEdit_optionOrder", function () {
    let checked = $(this).prop("checked");

    if (checked) {
      $(this).parent().prev().prop("disabled", true);
    } else {
      $(this).parent().prev().prop("disabled", false);
    }
  });

  // アクセス
  $(document).on("click", ".removeBtnAccess", function () {
    $(this).closest("tr").remove();

    if ($(".stRoomEdit_accessTbl tr").length === 1) {
      $(".stRoomEdit_accessTbl").hide();
    }
  });

  $(document).on("change", ".stRoomEdit_AccessSelect", function () {
    let selectedText = $(this).find("option:selected").text();
    $(this).next().text(selectedText);
    changeColor($(this).next());
  });

  // 予約受付期間
  $(document).on("change", ".stRoomEdit_reserveSelect", function () {
    let selectedText = $(this).find("option:selected").text();
    $(this).next().text(selectedText);
    changeColor($(this).next());
  });

  // スタジオ申請ボタン押下・ルーム申請ボタン押下
  $(".stRoomEdit_saveBtn-studio").on("click", function (e) {
    let errFlg = false;
    const errorNav = $(".stRoomEdit_errorNav").last();

    const errorMessages = {
      studioName: "【基本情報】スタジオの名称は120文字以内で入力してください。",
      address: "【基本情報】住所は200文字以内で入力してください。",
      catchphrase: "【基本情報】キャッチコピーは80文字以内で入力してください。",
      tel: "【基本情報】電話番号は13文字以内で入力してください。",
      inputSubject: "【予約メール】件名は108文字以内で入力してください。",
      inputMessage: "【予約メール】本文は4000文字以内で入力してください。",
    };

    if ($(".stRoomEdit_input-studioName").val().length > 120) {
      errFlg = true;
      $(".input_errMessage-studioName").show();
      if (errorNav.find(`.stRoomEdit_errorNavList:contains(${errorMessages.studioName})`).length === 0) {
        errorNav.append(`<li class="stRoomEdit_errorNavList">${errorMessages.studioName}</li>`);
      }
    } else {
      $(".input_errMessage-studioName").hide();
      errorNav.find(`.stRoomEdit_errorNavList:contains(${errorMessages.studioName})`).remove();
    }

    if ($(".stRoomEdit_input-address").val().length > 200) {
      errFlg = true;
      $(".input_errMessage-address").show();
      if (errorNav.find(`.stRoomEdit_errorNavList:contains(${errorMessages.address})`).length === 0) {
        errorNav.append(`<li class="stRoomEdit_errorNavList">${errorMessages.address}</li>`);
      }
    } else {
      $(".input_errMessage-address").hide();
      errorNav.find(`.stRoomEdit_errorNavList:contains(${errorMessages.address})`).remove();
    }

    if ($(".stRoomEdit_input-catchphrase").val().length > 80) {
      errFlg = true;
      $(".input_errMessage-catchphrase").show();
      if (errorNav.find(`.stRoomEdit_errorNavList:contains(${errorMessages.catchphrase})`).length === 0) {
        errorNav.append(`<li class="stRoomEdit_errorNavList">${errorMessages.catchphrase}</li>`);
      }
    } else {
      $(".input_errMessage-catchphrase").hide();
      errorNav.find(`.stRoomEdit_errorNavList:contains(${errorMessages.catchphrase})`).remove();
    }

    if ($(".stRoomEdit_input-tel").val().length > 13) {
      errFlg = true;
      $(".input_errMessage-tel").show();
      if (errorNav.find(`.stRoomEdit_errorNavList:contains(${errorMessages.tel})`).length === 0) {
        errorNav.append(`<li class="stRoomEdit_errorNavList">${errorMessages.tel}</li>`);
      }
    } else {
      $(".input_errMessage-tel").hide();
      errorNav.find(`.stRoomEdit_errorNavList:contains(${errorMessages.tel})`).remove();
    }

    // 予約メール
    const subjectValue = $("#subject").val();
    const messageValue = $("#message").val();

    if (subjectValue.length > 108) {
      $(".input_errMessage-inputSubject").show().text("※108文字以内で入力してください");
      errFlg = true;
      if (errorNav.find(`.stRoomEdit_errorNavList:contains(${errorMessages.inputSubject})`).length === 0) {
        errorNav.append(`<li class="stRoomEdit_errorNavList">${errorMessages.inputSubject}</li>`);
      }
    } else {
      if ($(".input_errMessage-inputSubject").is(":visible")) {
        $(".input_errMessage-inputSubject").hide();
      }
      errorNav.find(`.stRoomEdit_errorNavList:contains(${errorMessages.inputSubject})`).remove();
    }

    if (messageValue.length > 4000) {
      $(".input_errMessage-inputMessage").show().text("※4000文字以内で入力してください");
      errFlg = true;
      if (errorNav.find(`.stRoomEdit_errorNavList:contains(${errorMessages.inputMessage})`).length === 0) {
        errorNav.append(`<li class="stRoomEdit_errorNavList">${errorMessages.inputMessage}</li>`);
      }
    } else {
      if ($(".input_errMessage-inputMessage").is(":visible")) {
        $(".input_errMessage-inputMessage").hide();
      }
      errorNav.find(`.stRoomEdit_errorNavList:contains(${errorMessages.inputMessage})`).remove();
    }

    if (errFlg) {
      e.preventDefault();
      $("html, body").animate(
        {
          scrollTop: 0,
        },
        "fast"
      );
    }
  });

  // ルーム申請ボタン押下
  $(".stRoomEdit_saveBtn-room").on("click", function (e) {
    let errFlg = false;
    let errOptionFlg = false;
    let errPlanFlg = false;
    const errorNav = $(".stRoomEdit_errorNav").last();

    const errorMessages = {
      roomName: "【基本情報】ルームの名称は120文字以内で入力してください。",
      introduction: "【基本情報】紹介文は3000文字以内で入力してください。",
      optionInput: "【基本情報】オプション名は80文字以内で入力してください。",
      imgUrl: "【基本情報】360°VRビュー画像URLは9000文字以内で入力してください。",
      imgUrlFormat: "【基本情報】360°VRビュー画像URLは「https://view.ricoh360.com/」で始まる必要があります。",
      tableInputPlan: "【料金設定】プラン名は80文字以内で入力してください。",
      reserveMailSubject: "【予約メール】件名を入力してください。",
      reserveMailMessage: "【予約メール】本文を入力してください。",
      inputSubject: "【予約メール】件名は108文字以内で入力してください。",
      inputMessage: "【予約メール】本文は4000文字以内で入力してください。",
    };

    // ルームの名称
    if ($(".stRoomEdit_input-roomName").val().length > 120) {
      errFlg = true;
      $(".input_errMessage-roomName").show();
      if (errorNav.find(`.stRoomEdit_errorNavList:contains(${errorMessages.roomName})`).length === 0) {
        errorNav.append(`<li class="stRoomEdit_errorNavList">${errorMessages.roomName}</li>`);
      }
    } else {
      $(".input_errMessage-roomName").hide();
      errorNav.find(`.stRoomEdit_errorNavList:contains(${errorMessages.roomName})`).remove();
    }

    // 紹介文
    if ($(".stRoomEdit_input-introduction").val().length > 3000) {
      errFlg = true;
      $(".input_errMessage-introduction").show();
      if (errorNav.find(`.stRoomEdit_errorNavList:contains(${errorMessages.introduction})`).length === 0) {
        errorNav.append(`<li class="stRoomEdit_errorNavList">${errorMessages.introduction}</li>`);
      }
    } else {
      $(".input_errMessage-introduction").hide();
      errorNav.find(`.stRoomEdit_errorNavList:contains(${errorMessages.introduction})`).remove();
    }

    // オプション名
    $(".stRoomEdit_optionInput").each(function () {
      if ($(this).val().length > 80) {
        errFlg = true;
        errOptionFlg = true;
        $(this).prev(".input_errMessage-optionName").show();
      } else {
        $(this).prev(".input_errMessage-optionName").hide();
      }
    });
    if (errOptionFlg) {
      if (errorNav.find(`.stRoomEdit_errorNavList:contains(${errorMessages.optionInput})`).length === 0) {
        errorNav.append(`<li class="stRoomEdit_errorNavList">${errorMessages.optionInput}</li>`);
      }
    } else {
      errorNav.find(`.stRoomEdit_errorNavList:contains(${errorMessages.optionInput})`).remove();
    }

    // VRビューurl
    const imgUrl = $(".stRoomEdit_input-imgUrl").val();
    let imgUrlError = false;

    if (imgUrl) {
      // まずエラーメッセージを非表示にする
      $(".input_errMessage-imgUrl").hide();
      errorNav.find(`.stRoomEdit_errorNavList:contains(${errorMessages.imgUrl})`).remove();
      errorNav.find(`.stRoomEdit_errorNavList:contains(${errorMessages.imgUrlFormat})`).remove();

      // フォーマットチェック
      if (!imgUrl.startsWith("https://view.ricoh360.com/")) {
        errFlg = true;
        imgUrlError = true;
        $(".input_errMessage-imgUrl").show().text("※「https://view.ricoh360.com/」で始まるURLを入力してください。");
        if (errorNav.find(`.stRoomEdit_errorNavList:contains(${errorMessages.imgUrlFormat})`).length === 0) {
          errorNav.append(`<li class="stRoomEdit_errorNavList">${errorMessages.imgUrlFormat}</li>`);
        }
      }
      // 長さチェック（フォーマットが正しい場合のみ）
      else if (imgUrl.length > 9000) {
        errFlg = true;
        imgUrlError = true;
        $(".input_errMessage-imgUrl").show().text("※9000文字以内で入力してください。");
        if (errorNav.find(`.stRoomEdit_errorNavList:contains(${errorMessages.imgUrl})`).length === 0) {
          errorNav.append(`<li class="stRoomEdit_errorNavList">${errorMessages.imgUrl}</li>`);
        }
      }
    } else {
      $(".input_errMessage-imgUrl").hide();
      errorNav.find(`.stRoomEdit_errorNavList:contains(${errorMessages.imgUrl})`).remove();
      errorNav.find(`.stRoomEdit_errorNavList:contains(${errorMessages.imgUrlFormat})`).remove();
    }

    // プラン名
    $(".stRoomEdit_planBlockName").each(function () {
      if ($(this).val().length > 80) {
        errFlg = true;
        errPlanFlg = true;
        $(this).closest(".stRoomEdit_planBlock_field").find(".input_errMessage-planName").show();
      } else {
        $(this).closest(".stRoomEdit_planBlock_field").find(".input_errMessage-planName").hide();
      }
    });
    if (errPlanFlg) {
      if (errorNav.find(`.stRoomEdit_errorNavList:contains(${errorMessages.tableInputPlan})`).length === 0) {
        errorNav.append(`<li class="stRoomEdit_errorNavList">${errorMessages.tableInputPlan}</li>`);
      }
    } else {
      errorNav.find(`.stRoomEdit_errorNavList:contains(${errorMessages.tableInputPlan})`).remove();
    }

    $("#subject").each(function () {
      if ($(this).val().length > 108) {
        $(".input_errMessage-inputSubject").show().text("※108文字以内で入力してください");
        errFlg = true;
        if (errorNav.find(`.stRoomEdit_errorNavList:contains(${errorMessages.inputSubject})`).length === 0) {
          errorNav.append(`<li class="stRoomEdit_errorNavList">${errorMessages.inputSubject}</li>`);
        }
        errorNav.find(`.stRoomEdit_errorNavList:contains(${errorMessages.reserveMailSubject})`).remove();
      }
    });

    $("#message").each(function () {
      if ($(this).val().length > 4000) {
        $(".input_errMessage-inputMessage").show().text("※4000文字以内で入力してください");
        errFlg = true;
        if (errorNav.find(`.stRoomEdit_errorNavList:contains(${errorMessages.inputMessage})`).length === 0) {
          errorNav.append(`<li class="stRoomEdit_errorNavList">${errorMessages.inputMessage}</li>`);
        }
        errorNav.find(`.stRoomEdit_errorNavList:contains(${errorMessages.reserveMailMessage})`).remove();
      }
    });

    // ルーム公開時だけバリデーション実施
    if (!$(".stRoomEdit_grayout-public").hasClass("active") && $('input[name="room[published]"]:checked').val() === "1") {
      $("#subject").each(function () {
        if ($(this).val().length === 0) {
          $(".input_errMessage-inputSubject").show().text("※入力してください");
          errFlg = true;
          if (errorNav.find(`.stRoomEdit_errorNavList:contains(${errorMessages.reserveMailSubject})`).length === 0) {
            errorNav.append(`<li class="stRoomEdit_errorNavList">${errorMessages.reserveMailSubject}</li>`);
          }
          errorNav.find(`.stRoomEdit_errorNavList:contains(${errorMessages.inputSubject})`).remove();
        } else if ($(this).val().length <= 108) {
          if ($(".input_errMessage-inputSubject").is(":visible")) {
            $(".input_errMessage-inputSubject").hide();
          }
          errorNav.find(`.stRoomEdit_errorNavList:contains(${errorMessages.reserveMailSubject})`).remove();
          errorNav.find(`.stRoomEdit_errorNavList:contains(${errorMessages.inputSubject})`).remove();
        }
      });

      $("#message").each(function () {
        if ($(this).val().length === 0) {
          $(".input_errMessage-inputMessage").show().text("※入力してください");
          errFlg = true;
          if (errorNav.find(`.stRoomEdit_errorNavList:contains(${errorMessages.reserveMailMessage})`).length === 0) {
            errorNav.append(`<li class="stRoomEdit_errorNavList">${errorMessages.reserveMailMessage}</li>`);
          }
          errorNav.find(`.stRoomEdit_errorNavList:contains(${errorMessages.inputMessage})`).remove();
        } else if ($(this).val().length <= 4000) {
          if ($(".input_errMessage-inputMessage").is(":visible")) {
            $(".input_errMessage-inputMessage").hide();
          }
          errorNav.find(`.stRoomEdit_errorNavList:contains(${errorMessages.reserveMailMessage})`).remove();
          errorNav.find(`.stRoomEdit_errorNavList:contains(${errorMessages.inputMessage})`).remove();
        }
      });
    } else if (!$(".stRoomEdit_grayout-public").hasClass("active") && $('input[name="room[published]"]:checked').val() === "0") {
      $("#subject").each(function () {
        if ($(this).val().length <= 108) {
          if ($(".input_errMessage-inputSubject").is(":visible")) {
            $(".input_errMessage-inputSubject").hide();
          }

          errorNav.find(`.stRoomEdit_errorNavList:contains(${errorMessages.reserveMailSubject})`).remove();
          errorNav.find(`.stRoomEdit_errorNavList:contains(${errorMessages.inputSubject})`).remove();
        }
      });

      $("#message").each(function () {
        if ($(this).val().length <= 4000) {
          if ($(".input_errMessage-inputMessage").is(":visible")) {
            $(".input_errMessage-inputMessage").hide();
          }

          errorNav.find(`.stRoomEdit_errorNavList:contains(${errorMessages.reserveMailMessage})`).remove();
          errorNav.find(`.stRoomEdit_errorNavList:contains(${errorMessages.inputMessage})`).remove();
        }
      });
    }

    if (errFlg) {
      e.preventDefault();
      $("html, body").animate(
        {
          scrollTop: 0,
        },
        "fast"
      );
    }
  });

  // 選択した都道府県から路線の選択肢を作成
  $(document).on("change", ".stRoomEdit_AccessSelect-prefecture", function (e) {
    let selectedPrefOption = $(this).find("option:selected");

    $.ajax({
      type: "GET",
      url: "/get_lines",
      data: {
        prefecture_id: selectedPrefOption.val(),
      },
      dataType: "json",
      timeout: 10000,
      cache: false,
    })
      .done(function (data, textStatus, jqXHR) {
        let selectLine = selectedPrefOption.closest("td").next().find(".stRoomEdit_AccessSelect-line");
        let selectStation = selectedPrefOption.closest("td").next().next().find(".stRoomEdit_AccessSelect-station");
        clearOption(selectLine);
        clearOption(selectStation);
        for (var i = 0; i < data.length; i++) {
          const option = $("<option>").val(data[i].id).text(data[i].name);
          selectLine.append(option);
        }
      })
      .fail(function (jqXHR, textStatus, errorThrown) {})
      .always(function () {});
  });

  // 選択した路線から駅の選択肢を作成
  $(document).on("change", ".stRoomEdit_AccessSelect-line", function (e) {
    let selectedLineOption = $(this).find("option:selected");
    let selectPref = selectedLineOption.closest("td").prev().find(".stRoomEdit_AccessSelect-prefecture");
    let selectedPrefOption = selectPref.find("option:selected");

    $.ajax({
      type: "GET",
      url: "/get_stations",
      data: {
        prefecture_id: selectedPrefOption.val(),
        line_id: selectedLineOption.val(),
      },
      dataType: "json",
      timeout: 10000,
      cache: false,
    })
      .done(function (data, textStatus, jqXHR) {
        let selectStation = selectedLineOption.closest("td").next().find(".stRoomEdit_AccessSelect-station");
        clearOption(selectStation);
        for (var i = 0; i < data.length; i++) {
          const option = $("<option>").val(data[i].id).text(data[i].name);
          selectStation.append(option);
        }
      })
      .fail(function (jqXHR, textStatus, errorThrown) {})
      .always(function () {});
  });

  function clearOption(select_elem) {
    select_elem.val(null);
    select_elem.find("option:not(:disabled)").remove();
    let disabledText = select_elem.find("option:disabled").text();
    select_elem.next().text(disabledText).css("color", "#b19ba5");
  }

  // 料金設定 枠追加・削除
  $(document).on("click", ".removeBtnCancel", function () {
    $(this).closest(".st_btnWrapper").remove();
  });

  // url切り替わりなし対策
  $(".stRoomEdit_headerTitle").hide();
  $(".stRoomEdit_headerTitle").eq(0).show();

  $(".stRoomEdit_mainDetail").hide();
  $(".stRoomEdit_mainDetail").eq(0).show();

  // topボタン切り替え
  $(document).on("click", ".st_headerList", function () {
    if ($(this).hasClass("grayout")) {
      return;
    }

    let index = $(".st_headerList").index(this);
    $(".st_headerList").removeClass("active");
    $(this).addClass("active");

    $(".stRoomEdit_headerTitle").hide();
    $(".stRoomEdit_headerTitle").eq(index).show();

    $(".stRoomEdit_mainDetail").hide();
    $(".stRoomEdit_mainDetail").eq(index).show();

    // 予約管理画面用
    $(".stRoomRes_main").hide();
    $(".stRoomRes_main").eq(index).show();
    $(".stRoomRes_detail").hide();

    // 予約管理画面用
    $(".stCalendar_contents").hide();
    $(".stCalendar_contents").eq(index).show();
  });

  // 曜日表示
  // 曜日を選択したらチェック & 曜日をテキストに表示 & 曜日の選択状態（ビットマスク値）を隠しフィールドに反映
  $(".stRoomEdit_mainDetail").on("click", ".stRoomEdit_weekMenu", function (e) {
    const imgElement = $("<img>", {
      class: "search_img",
      src: "/assets/down-e8bf3054e87e306d8a948837be3e07b7ab3fef1b9d2742ae154a8466bf66999a.png",
    });

    let checkbox = $(this).find('input[type="checkbox"]');

    if (!$(e.target).is('input[type="checkbox"]')) {
      checkbox.prop("checked", !checkbox.prop("checked"));
    }

    let selectedValues = "";

    let checkedCheckboxes = $(this).closest(".stRoomEdit_weekMenuWrapper").find('input[type="checkbox"]:checked');
    let mask = 0

    checkedCheckboxes.each(function () {
      switch ($(this).val()) {
        case "0":
          selectedValues += "日, ";
          mask |= (1 << 0);
          break;
        case "1":
          selectedValues += "月, ";
          mask |= (1 << 1);
          break;
        case "2":
          selectedValues += "火, ";
          mask |= (1 << 2);
          break;
        case "3":
          selectedValues += "水, ";
          mask |= (1 << 3);
          break;
        case "4":
          selectedValues += "木, ";
          mask |= (1 << 4);
          break;
        case "5":
          selectedValues += "金, ";
          mask |= (1 << 5);
          break;
        case "6":
          selectedValues += "土, ";
          mask |= (1 << 6);
          break;
        case "7":
          selectedValues += "祝, ";
          mask |= (1 << 7);
          break;
      }
    });

    selectedValues = selectedValues.slice(0, -2);

    let weekLabel = $(this).closest(".stRoomEdit_weekMenuWrapper").prev().prev();
    if (selectedValues === "") {
      weekLabel.text("曜日");
      weekLabel.css("color", "#b19ba5");
    } else {
      weekLabel.text(selectedValues);
      weekLabel.css("color", "#000");
    }
    weekLabel.append(imgElement);

    $(this).closest(".stRoomEdit_weekMenuWrapper").find('.stRoomEdit_rateRowWeekdayMask').val(mask);
  });

  // input要素をクリックしたらメニューを表示
  $(".stRoomEdit_mainDetail").on("click", ".stRoomEdit_weekLabel", function (e) {
    e.stopPropagation();

    let checkbox = $(this).next(".stRoomEdit_weekMenuBar");
    checkbox.prop("checked", !checkbox.prop("checked"));

    if ($(this).next(".stRoomEdit_weekMenuBar").is(":checked")) {
      $(".stRoomEdit_weekMenuWrapper").css("display", "none");
      $(".stRoomEdit_plan").removeClass("weekmenu-open");
      $(this).next(".stRoomEdit_weekMenuBar").next(".stRoomEdit_weekMenuWrapper").css("display", "block");
      $(this).closest(".stRoomEdit_plan").addClass("weekmenu-open");
    } else {
      $(this).next(".stRoomEdit_weekMenuBar").next(".stRoomEdit_weekMenuWrapper").css("display", "none");
      $(this).closest(".stRoomEdit_plan").removeClass("weekmenu-open");
    }
  });

  $(".stRoomEdit_mainDetail").on("click", ".stRoomEdit_weekMenuWrapper", function (event) {
    event.stopPropagation();
  });

  $(document).on("click", function (event) {
    if (!$(event.target).closest(".stRoomEdit_weekMenuBar").length) {
      $(".stRoomEdit_weekMenuBar").prop("checked", false);
      $(".stRoomEdit_weekMenuBar").next(".stRoomEdit_weekMenuWrapper").css("display", "none");
      $(".stRoomEdit_plan").removeClass("weekmenu-open");
    }
  });

  function togglePreviewInput() {
    if ($(".stRoomEdit_previewMain .stRoomEdit_previewImg").length >= 1) {
      $(".stRoomEdit_previewMain .stRoomEdit_previewInput").hide();
    } else {
      $(".stRoomEdit_previewMain .stRoomEdit_previewInput").show();
    }

    if ($(".stRoomEdit_previewFloor .stRoomEdit_previewImg").length >= 1) {
      $(".stRoomEdit_previewFloor .stRoomEdit_previewInput").hide();
    } else {
      $(".stRoomEdit_previewFloor .stRoomEdit_previewInput").show();
    }

    if ($(".stRoomEdit_previewSub .stRoomEdit_previewImg").length >= 50) {
      $(".stRoomEdit_previewSub .stRoomEdit_previewInput").hide();
    } else {
      $(".stRoomEdit_previewSub .stRoomEdit_previewInput").show();
    }
  }

  // 利用用途
  $(document).on("change", ".reservation_select", function () {
    let selectedText = $(this).find("option:selected").text();

    $(this).next().text(selectedText);
    changeColor($(this).next());
  });

  // ---- スタジオ編集画面 ----
  // ルーム 写真追加機能
  $("#previewMainInput , #previewFloorInput , #previewSubInput").on("change", function (event) {
    event.preventDefault();

    const files = event.target.files;
    if (files.length === 0) {
      return;
    }

    const options = {
      maxSizeMB: 0.5,
      maxWidthOrHeight: 1920,
    };

    Array.from(files).forEach((file) => {
      imageCompression(file, options)
        .then(function (compressedFile) {
          const reader = new FileReader();
          reader.fileName = compressedFile.name;

          reader.onload = function (e) {
            const imgContainer = $("<div>").addClass("stRoomEdit_previewImg");
            const closeBtn = $("<img>").attr("src", "/assets/img_close-4ce0434839b7e0d891424f7f358330b2031a9c40507fb41bcd7c08f4c0528506.png").addClass("stRoomEdit_imgClose");
            const img = $("<img>").attr("src", e.target.result).addClass("stRoomEdit_img");
            imgContainer.append(closeBtn, img);

            if (event.target.id === "previewMainInput") {
              const text = $("<input>", {
                type: "text",
              })
                .attr("name", "room[main_images][][filename]")
                .val(e.target.fileName)
                .hide();
              const textarea = $("<textarea>").attr("name", "room[main_images][][base64_data]").val(e.target.result).hide();
              imgContainer.append(text, textarea);
              if ($(".stRoomEdit_previewMain .stRoomEdit_previewImg").length < 1) {
                $(".stRoomEdit_previewMainInput").before(imgContainer);
              }
            } else if (event.target.id === "previewSubInput") {
              const text = $("<input>", {
                type: "text",
              })
                .attr("name", "room[sub_images][][filename]")
                .val(e.target.fileName)
                .hide();
              const textarea = $("<textarea>").attr("name", "room[sub_images][][base64_data]").val(e.target.result).hide();
              imgContainer.append(text, textarea);
              if ($(".stRoomEdit_previewSub .stRoomEdit_previewImg").length < 50) {
                $(".stRoomEdit_previewSubInput").before(imgContainer);
              }
            } else if (event.target.id === "previewFloorInput") {
              const text = $("<input>", {
                type: "text",
              })
                .attr("name", "room[floor_plan_images][][filename]")
                .val(e.target.fileName)
                .hide();
              const textarea = $("<textarea>").attr("name", "room[floor_plan_images][][base64_data]").val(e.target.result).hide();
              imgContainer.append(text, textarea);
              if ($(".stRoomEdit_previewFloor .stRoomEdit_previewImg").length < 1) {
                $(".stRoomEdit_previewFloorInput").before(imgContainer);
              }
            }

            closeBtn.on("click", function () {
              $(this).closest(".stRoomEdit_previewImg").remove();
              togglePreviewInput();
            });

            togglePreviewInput();
          };

          reader.readAsDataURL(compressedFile);
        })
        .catch(function (error) {
          console.log(error.message);
        });
    });

    $(this).val("");
  });
  togglePreviewInput();

  $(".stRoomEdit_imgClose").on("click", function () {
    $(this).closest(".stRoomEdit_previewImg").remove();
    togglePreviewInput();
  });

  $("#stRoomEdit_width").on("blur", function () {
    const inputValue = Math.floor($(this).val() / 90) / 2;
    const select = $("#stRoomEdit_bamiri");
    const options = select.children("option");

    options.each(function () {
      if ($(this).val() === String(inputValue)) {
        select.val(inputValue);
        return false;
      }
    });

    if (inputValue <= 0.5) {
      select.val("0.5");
    } else if (inputValue >= 10) {
      select.val("10");
    }

    $(".pulldown_bamiri").text(select.find("option:selected").text());
    changeColor(".pulldown_bamiri");
  });

  $(".stRoomEdit_form").on("keydown", "input", function (event) {
    if (event.key === "Enter") {
      event.preventDefault();
      setTimeout(() => {
        $(this).blur();
      });
    }
  });

  $("#stRoomEdit_bamiri").on("change", function () {
    let selectedText = $(this).find("option:selected").text();

    $(".pulldown_bamiri").text(selectedText);
    changeColor(".pulldown_bamiri");
  });

  // 営業時間のセレクトボックス処理（全曜日対応）
  const days = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];
  
  // 各曜日の営業時間セレクトボックスにイベントリスナーを設定
  days.forEach(day => {
    $(`#start_businessHour_${day}`).on("change", function () {
      let selectedText = $(this).find("option:selected").text();
      let daySelector = `.pulldown_startBusinessHour_${day}`;
      
      $(daySelector).text(selectedText);
      changeColor(daySelector);

      // 開始分が未設定の場合、デフォルト値を設定
      if ($(`#start_businessMinute_${day}`).val() === null) {
        $(`#start_businessMinute_${day}`).val(0);
        $(`.pulldown_startBusinessMinute_${day}`).text("00");
        changeColor(`.pulldown_startBusinessMinute_${day}`);
      }

      // 終了時間が未設定または開始時間より早い場合、自動調整
      if ($(`#end_businessHour_${day}`).val() === null || parseInt(selectedText) >= parseInt($(`#end_businessHour_${day}`).val())) {
        let endHour;
        if (Number(selectedText) >= 16) {
          endHour = Number(selectedText) - 16;
        } else {
          endHour = parseInt(selectedText) + 8;
        }
        $(`#end_businessHour_${day}`).val(endHour);
        $(`.pulldown_endBusinessHour_${day}`).text(endHour);
        changeColor(`.pulldown_endBusinessHour_${day}`);
      }

      // 終了分が未設定の場合、デフォルト値を設定
      if ($(`#end_businessMinute_${day}`).val() === null) {
        $(`#end_businessMinute_${day}`).val(0);
        $(`.pulldown_endBusinessMinute_${day}`).text("00");
        changeColor(`.pulldown_endBusinessMinute_${day}`);
      }
    });

    // 開始時間（分）
    $(`#start_businessMinute_${day}`).on("change", function () {
      let selectedText = $(this).find("option:selected").text();
      let daySelector = `.pulldown_startBusinessMinute_${day}`;
      
      $(daySelector).text(selectedText);
      changeColor(daySelector);
    });

    // 終了時間（時）
    $(`#end_businessHour_${day}`).on("change", function () {
      let selectedText = $(this).find("option:selected").text();
      let daySelector = `.pulldown_endBusinessHour_${day}`;
      
      $(daySelector).text(selectedText);
      changeColor(daySelector);
    });

    // 終了時間（分）
    $(`#end_businessMinute_${day}`).on("change", function () {
      let selectedText = $(this).find("option:selected").text();
      let daySelector = `.pulldown_endBusinessMinute_${day}`;
      
      $(daySelector).text(selectedText);
      changeColor(daySelector);
    });
  });

  // 定休日チェックボックスの処理
  days.forEach(day => {
    $(`#closed_day_${day}`).on("change", function () {
      const isClosed = $(this).is(':checked');
      const businessHoursContainer = $(this).closest('.stRoomEdit_businessHoursBox').find('.stRoomEdit_businessHours');
      
      if (isClosed) {
        // 定休日の場合は営業時間セクションを非表示
        businessHoursContainer.hide();
      } else {
        // 定休日でない場合は営業時間セクションを表示
        businessHoursContainer.show();
      }
    });
  });

  // 予約締め切り時間
  $("#reservationEndHour").on("change", function () {
    let selectedText = $(this).find("option:selected").text();

    $(".pulldown_reservationEndHour").text(selectedText);
    changeColor(".pulldown_reservationEndHour");
  });

  $("#reservationEndMinute").on("change", function () {
    let selectedText = $(this).find("option:selected").text();

    $(".pulldown_reservationEndMinute").text(selectedText);
    changeColor(".pulldown_reservationEndMinute");
  });

  // カレンダーの設定
  $(document).on("change", ".stCalendar_select", function () {
    let selectedText = $(this).find("option:selected").text();

    $(this).next().text(selectedText);
    changeColor($(this).next());
  });

  window.addEventListener("pageshow", function () {
    $(".stCalendar_btn").removeClass("disable_button");
  });

  // クリック時 カーソルオフ
  $(".stCalendar_btn").on("click", function () {
    $(this).addClass("disable_button");
  });

  $(".st_select option").each(function () {
    let optionText = $(this).text();
    if (optionText.length > 20) {
      $(this).text(optionText.slice(0, 20) + "...");
    }
  });

  $(document).on("click", ".stUserEdit_editBtn", function (e) {
    $(this).closest(".stUserEdit_form").find("input[type='checkbox']").val("1");
    $(this).closest(".stUserEdit_form").find("input[type='hidden']").remove();
    let $inputField = $(this).closest(".stUserEdit_form").find("input");

    if ($inputField.prop("disabled")) {
      $inputField.prop("disabled", false).focus();
      $(this).addClass("active");
    }
  });

  $(document).on("click", ".stUserEdit_deleteBtn", function (e) {
    $(this).closest(".stUserEdit_contents").remove();
  });

  $(".stUserEdit_addBtn").on("click", function () {
    let lastUserNumText = $(".stUserEdit_userNum").last().text();
    let lastUserNum = parseInt(lastUserNumText, 10) || 0;
    let newUserNum = lastUserNum + 1;

    $(".stUserEdit_contents")
      .last()
      .after(
        `<div class="stUserEdit_contents">
                <div class="stUserEdit_jointManagement">
                    <h2 class="stUserEdit_infoTitle">共同管理者 <span class="stUserEdit_userNum">${newUserNum}</span></h2>
                    <button type="button" class="button stUserEdit_deleteBtn">共同管理者を削除</button>
                </div>
                <input type="hidden" name="owner[sub_owner_uuids][]" value="" autocomplete="off">
                <p class="stUserEdit_subTxt">＊共同管理者には掲載者宛てのメールと同じメールが届きます。</p>
                <div class="stUserEdit_form">
                    <div class="stUserEdit_formTitle">
                        <label>氏名</label>
                        <button type="button" class="button stUserEdit_editBtn">修正</button>
                    </div>
                    <input type="hidden" name="owner[sub_owner_owner_names][]" value="" autocomplete="off">
                    <input class="stUserEdit_input" type="text" name="owner[sub_owner_owner_names][]" disabled placeholder="氏名">
                    <input type="checkbox" name="owner[sub_owner_owner_names_changed][]" value="0" style="display:none" checked>
                </div>
                <div class="stUserEdit_form">
                    <div class="stUserEdit_formTitle">
                        <label>メールアドレス</label>
                        <button type="button" class="button stUserEdit_editBtn">修正</button>
                    </div>
                    <input type="hidden" name="owner[sub_owner_emails][]" value="" autocomplete="off">
                    <input class="stUserEdit_input" type="text" name="owner[sub_owner_emails][]" disabled placeholder="メールアドレス">
                    <input type="checkbox" name="owner[sub_owner_emails_changed][]" value="0" style="display:none" checked>
                </div>
            </div>`
      );
  });

  // ユーザー情報編集
  const inputFields = $(".mypageRoom_input");

  function checkInputs() {
    const allFilled = inputFields.toArray().every((input) => $(input).val().trim() !== "");
    $("#edit_button").prop("disabled", !allFilled);
  }

  inputFields.on("input", checkInputs);

  // 連打防止対策リスト
  const targetButtons = {
    '#register_button': null,
    '#reservation_paymentButton': null,
    '#reservation_cancelBtn': null,
    '#cancel_reservationButton': null,
    '#take_receiptButton': 1000,
    '#studio_register_button': null,
    '#studio_auth_button': null,
    '#studio_calendar_setting_button': null,
    '#studio_revoke_account_button': null,
    '#reservation_approveBtn': null,
    '#userCancelBtn': null,
    '#studio_statement_download_button': 1000,
    '#apply_coupon_button': null,
    '#studio_auth_password_button': null,
    '#studio_account_register_button': null
  };

  Object.keys(targetButtons).forEach(function (selector) {
    const $button = $(selector);
    const timeout = targetButtons[selector];

    // submitボタン（フォーム送信用）は、formのsubmitイベントで無効化
    if ($button.attr('type') === 'submit') {
      $button.closest('form').on('submit.preventDoubleSubmit', function (e) {
        if ($button.prop('disabled')) {
          e.preventDefault();
          return false;
        }
        $button.prop('disabled', true);
        
        // タイムアウトが設定されていれば、指定時間後に解除
        if (timeout) {
          setTimeout(function () {
            $button.prop('disabled', false);
          }, timeout);
        }
      });
    } else {
      // 通常ボタン（type="button"）またはaタグはクリック時に無効化
      $button.on('click.preventDoubleClick', function (e) {
        // aタグの場合は、disabled属性が使えないためクラスで制御
        if ($button.is('a')) {
          if ($button.hasClass('disabled')) {
            e.preventDefault();
            return false;
          }
          $button.addClass('disabled');
          
          // タイムアウトが設定されていれば、指定時間後に解除
          if (timeout) {
            setTimeout(function () {
              $button.removeClass('disabled');
            }, timeout);
          }
        } else {
          // button要素の場合は、disabled属性を使用
          if ($button.prop('disabled')) {
            e.preventDefault();
            return false;
          }
          $button.prop('disabled', true);
          
          // タイムアウトが設定されていれば、指定時間後に解除
          if (timeout) {
            setTimeout(function () {
              $button.prop('disabled', false);
            }, timeout);
          }
        }
      });
    }
  });
}

$(document).on("turbo:load", initialize);
$(document).on("turbo:submit-end", function (event) {
  // フォーム送信のバリデーションエラー時に再初期化する
  if (!event.detail.success) {
    needsReinitAfterRender = true;
  }
});
$(document).on("turbo:render", function (event) {
  if (!needsReinitAfterRender) return;

  needsReinitAfterRender = false;

  initialize();
});


// 情報アイコン ツールチップ（クリックで開閉、外側クリックで閉じる）
$(document).on("click", function (e) {
  const $clickedIcon = $(e.target).closest(".info-icon");

  if ($clickedIcon.length) {
    e.stopPropagation();
    const willOpen = !$clickedIcon.hasClass("is-open");
    $(".info-icon.is-open").removeClass("is-open");
    if (willOpen) {
      $clickedIcon.addClass("is-open");
    }
  } else {
    $(".info-icon.is-open").removeClass("is-open");
  }
});

// フリーワードアイコン ツールチップ（クリックで開閉、外側クリックで閉じる）
// ページ読み込み時にラジオボタングループのサイズを固定し、ツールチップ位置を初期化
function initFreewordIcons() {
  $(".freeword-icon").each(function() {
    const $icon = $(this);
    
    // 既に初期化済みの場合はスキップ
    if ($icon.data("tooltip-initialized")) {
      return;
    }
    
    // ツールチップの位置を計算して固定
    const iconRect = this.getBoundingClientRect();
    
    // 要素が表示されていない場合はスキップ（ポップアップが閉じている場合など）
    if (iconRect.width === 0 && iconRect.height === 0) {
      return;
    }
    
    const tooltipWidth = 260; // width 240px + padding左右各10px
    const viewportWidth = window.innerWidth || document.documentElement.clientWidth;
    const margin = 20; // 画面端からの余白
    
    // アイコンの中心位置（ビューポート基準）
    const iconCenterX = iconRect.left + iconRect.width / 2;
    
    // 中央配置の場合のツールチップの左右位置（ビューポート基準）
    let tooltipLeftViewport = iconCenterX - tooltipWidth / 2;
    
    // 画面内に収まるように位置を調整
    if (tooltipLeftViewport < margin) {
      tooltipLeftViewport = margin;
    } else if (tooltipLeftViewport + tooltipWidth > viewportWidth - margin) {
      tooltipLeftViewport = viewportWidth - tooltipWidth - margin;
    }
    
    // アイコン要素の左端からの相対位置を計算
    const iconLeftViewport = iconRect.left;
    const tooltipLeftRelative = tooltipLeftViewport - iconLeftViewport;
    
    // アイコンの中心からの相対位置（矢印用）
    const arrowLeftRelative = iconRect.width / 2;

    // CSS変数を最初から設定（常に同じ値）
    $icon.css({
      "--tooltip-left": tooltipLeftRelative + "px",
      "--tooltip-transform": "translateX(0)",
      "--arrow-left": arrowLeftRelative + "px"
    });
    
    $icon.data("tooltip-initialized", true);
  });
}

// ラジオボタングループのサイズを固定
function fixRadioGroupSizes() {
  $(".search_radio-group").each(function() {
    const $group = $(this);
    const $labels = $group.find(".search_radio-label");
    
    // 既に固定されている場合はスキップ
    if ($group.data("size-fixed")) {
      return;
    }
    
    // 各ラベルの幅を測定して固定
    $labels.each(function() {
      const $label = $(this);
      const width = $label.outerWidth();
      if (width > 0) {
        $label.css({
          "min-width": width + "px",
          "width": width + "px"
        });
      }
    });
    
    // グループ全体の幅も固定
    const groupWidth = $group.outerWidth();
    if (groupWidth > 0) {
      $group.css({
        "min-width": groupWidth + "px",
        "width": groupWidth + "px"
      });
      $group.data("size-fixed", true);
    }
  });
}

// 初期化関数（画面遷移後も呼ばれる）
function initFreewordIconTooltips() {
  // 既存のCSS変数とフラグをリセット
  $(".search_radio-group").removeData("size-fixed").css({
    "min-width": "",
    "width": ""
  });
  $(".search_radio-label").css({
    "min-width": "",
    "width": ""
  });
  $(".freeword-icon").removeData("tooltip-initialized").css({
    "--tooltip-left": "",
    "--tooltip-transform": "",
    "--arrow-left": ""
  });
  
  // 再初期化
  setTimeout(function() {
    fixRadioGroupSizes();
    initFreewordIcons();
  }, 50);
}

// DOM読み込み完了時とTurbo遷移後に実行
$(document).ready(function() {
  initFreewordIconTooltips();
});

// Turbo Driveのページ遷移後にも初期化
$(document).on("turbo:load", function() {
  initFreewordIconTooltips();
});

$(window).on("resize", function() {
  // リサイズ時は一度解除してから再固定
  $(".search_radio-group").removeData("size-fixed").css({
    "min-width": "",
    "width": ""
  });
  $(".search_radio-label").css({
    "min-width": "",
    "width": ""
  });
  $(".freeword-icon").removeData("tooltip-initialized").css({
    "--tooltip-left": "",
    "--tooltip-transform": "",
    "--arrow-left": ""
  });
  
  setTimeout(function() {
    fixRadioGroupSizes();
    initFreewordIcons();
  }, 100);
});

// クリック時はクラスの追加/削除のみ（CSS変数は変更しない）
$(document).on("click", ".freeword-icon", function (e) {
  e.stopPropagation();
  e.preventDefault();
  const $clickedIcon = $(this);
  const willOpen = !$clickedIcon.hasClass("is-open");
  $(".freeword-icon.is-open").removeClass("is-open");
  if (willOpen) {
    $clickedIcon.addClass("is-open");
  }
});

$(document).on("click", function (e) {
  if (!$(e.target).closest(".freeword-icon").length) {
    $(".freeword-icon.is-open").removeClass("is-open");
  }
});

// マップ初期化関数
function initializeMap() {
  const $mapElement = $("#map");

  // 地図要素が存在しない場合は処理を終了
  if (!$mapElement.length) return;

  const address = $mapElement.data("address");
  if (!address) {
    $(".room_map").hide();
    return;
  }

  // Google Maps APIが読み込まれているかチェック
  if (typeof google === 'undefined' || typeof google.maps === 'undefined') {
    setTimeout(initializeMap, 200);
    return;
  }

  // ジオコーディングのインスタンスを生成
  try {
    const geocoder = new google.maps.Geocoder();

    // 住所から座標を取得
    geocoder.geocode({ address: address }, function (results, status) {
      if (status === "OK" && results && results[0] && results[0].geometry && results[0].geometry.location) {
        const location = results[0].geometry.location;

        // 座標が有効な数値であることを確認
        const lat = location.lat();
        const lng = location.lng();

        if (isFinite(lat) && isFinite(lng)) {
          // 地図の作成
          const mapOptions = {
            zoom: 16,
            center: { lat: lat, lng: lng },
            mapTypeId: "roadmap",
          };

          const map = new google.maps.Map($mapElement[0], mapOptions);

          // マーカーの作成
          new google.maps.Marker({
            map: map,
            position: { lat: lat, lng: lng },
          });
        } else {
          $(".room_map").hide();
        }
      } else {
        $(".room_map").hide();
      }
    });
  } catch (error) {
    console.error("Google Maps initialization error:", error);
    $(".room_map").hide();
  }
}

// より確実な初期化方法
function ensureMapInitialization() {
  // Google Maps APIが読み込まれているかチェック
  if (typeof google === 'undefined' || typeof google.maps === 'undefined') {
    // 最大10秒間（50回）試行
    let attempts = 0;
    const maxAttempts = 50;
    
    const checkAndInitialize = () => {
      attempts++;
      if (typeof google !== 'undefined' && typeof google.maps !== 'undefined') {
        initializeMap();
      } else if (attempts < maxAttempts) {
        setTimeout(checkAndInitialize, 200);
      } else {
        console.error("Google Maps API failed to load after", maxAttempts, "attempts");
      }
    };
    
    checkAndInitialize();
  } else {
    initializeMap();
  }
}

// 複数のイベントでマップを初期化
$(document).on("turbo:load", ensureMapInitialization);
$(document).ready(ensureMapInitialization);
$(window).on("load", ensureMapInitialization);

// 予約キャンセル確認モーダル
function initializeCancelModal() {
  const $modal = $("#cancelModal");
  const $cancelBtn = $("#cancelReservationBtn");
  const $closeBtn = $("#closeModal");
  const $cancelModalBtn = $("#cancelModalBtn");

  if (!$modal.length || !$cancelBtn.length) return;

  // モーダルの初期状態を設定
  $modal.hide();

  // キャンセルボタンクリック時の処理
  $cancelBtn.on("click", function (e) {
    e.preventDefault();
    $modal.css("display", "flex");
  });

  // 閉じるボタンクリック時の処理
  $closeBtn.on("click", function () {
    $modal.hide();
  });

  // キャンセルボタンクリック時の処理
  $cancelModalBtn.on("click", function () {
    $modal.hide();
  });

  // モーダル外をクリックした時の処理
  $(window).on("click", function (e) {
    if (e.target === $modal[0]) {
      $modal.hide();
    }
  });
}

// Turboの各イベントでモーダルを初期化
$(document).on("turbo:load", initializeCancelModal);
$(document).on("turbo:render", initializeCancelModal);
$(document).on("turbo:frame-load", initializeCancelModal);

// 予約管理画面 モーダル制御
function initializeReservationModals() {
  // 既存のイベントハンドラーを削除
  $(document).off("click", ".reservation_approveBtn");
  $(document).off("click", ".reservation_cancelBtn");
  $(document).off("click", ".user_reservation_cancelBtn");
  $(document).off("click", "#reservation_approveBtn");
  $(document).off("click", "#reservation_cancelBtn");
  $(document).off("click", "#userCancelBtn");
  $("#closeApproveModal, #cancelApproveModalBtn").off("click");
  $("#closeCancelModal, #cancelModalBtn").off("click");
  $("#closeUserCancelModal, #cancelUserCancelModalBtn").off("click");
  $(window).off("click");

  const $approveModal = $("#approveModal");
  const $cancelModal = $("#cancelModal");
  const $userCancelModal = $("#userCancelModal");
  const $loadingOverlay = $("#loadingOverlay");

  // 承認モーダルの制御
  $(document).on("click", ".reservation_approveBtn", function (e) {
    e.preventDefault();

    // モーダル内のフォームのactionを更新
    const $modalApproveForm = $approveModal.find(".modal-form");
    $modalApproveForm.attr("action", $(this).data("reservation-approve-path"));

    // 同じ時間帯に重なる承認待ちリクエストがあれば、承認と同時に自動でお断りすることを伝える
    const overlappingCount = parseInt($(this).data("overlapping-request-count"), 10) || 0;
    const $approveMessage = $approveModal.find(".modal-message");
    if (overlappingCount > 0) {
      $approveMessage.text(
        "本当に予約を承認しますか？承認すると、同じ時間帯に重なっている他の予約リクエスト" +
          overlappingCount +
          "件は自動でお断りします。"
      );
    } else {
      $approveMessage.text("本当に予約を承認しますか？");
    }

    $approveModal.css("display", "flex");
  });

  // キャンセルモーダルの制御（承認ボタンエリア用）
  $(document).on("click", ".reservation_cancelBtn", function (e) {
    e.preventDefault();

    // モーダル内のフォームのactionを更新
    const $modalCancelForm = $cancelModal.find(".modal-form");
    $modalCancelForm.attr("action", $(this).data("reservation-cancel-path"));

    $cancelModal.css("display", "flex");
  });

  // ユーザーキャンセルモーダルの制御（キャンセル欄用）
  $(document).on("click", ".user_reservation_cancelBtn", function (e) {
    e.preventDefault();

    // モーダル内のフォームのactionを更新
    const $modalUserCancelForm = $userCancelModal.find(".modal-form");
    $modalUserCancelForm.attr("action", $(this).data("user-cancel-path"));

    $userCancelModal.css("display", "flex");
  });

  // モーダルを閉じる処理
  function closeModal($modal) {
    $modal.hide();
  }

  function disabledTurboElements() {
    $(".reservation_approveBtn").prop("disabled", true);
    $(".reservation_cancelBtn").prop("disabled", true);
    $(".user_reservation_cancelBtn").prop("disabled", true);
    $("[id=reservation_filter_studio]").prop("disabled", true);
    $("[id=reservation_filter_room]").prop("disabled", true);
    $("[id=reservation_filter_yearmonth]").prop("disabled", true);
    $("[id=reservation_filter_calendar_yearmonth]").prop("disabled", true);
  }

  function enableTurboElements() {
    $(".reservation_approveBtn").prop("disabled", false);
    $(".reservation_cancelBtn").prop("disabled", false);
    $(".user_reservation_cancelBtn").prop("disabled", false);
    $("[id=reservation_filter_studio]").prop("disabled", false);
    $("[id=reservation_filter_room]").prop("disabled", false);
    $("[id=reservation_filter_yearmonth]").prop("disabled", false);
    $("[id=reservation_filter_calendar_yearmonth]").prop("disabled", false);
  }

  function hideLoadingOverlay() {
    $loadingOverlay.hide();
    enableTurboElements();
  }

  // 承認モーダルのイベントリスナー
  $("#closeApproveModal, #cancelApproveModalBtn").on("click", function () {
    closeModal($approveModal);
  });

  // 承認ボタンクリック時の処理
  $(document).on("click", "#reservation_approveBtn", function () {
    disabledTurboElements();
    $loadingOverlay.css("display", "flex");
    closeModal($approveModal);
  });

  document.addEventListener("turbo:submit-end", function (event) {
    if (event.target.id === "reservation_approveForm") {
      hideLoadingOverlay();
    }
  });

  // エラー時の処理
  document.addEventListener("turbo:frame-missing", function (event) {
    if ($loadingOverlay.is(":visible")) {
      hideLoadingOverlay();
    }
  });

  document.addEventListener("turbo:fetch-request-error", function (event) {
    if ($loadingOverlay.is(":visible")) {
      hideLoadingOverlay();
    }
  });

  // キャンセルモーダルのイベントリスナー（承認ボタンエリア用）
  $("#closeCancelModal, #cancelModalBtn").on("click", function () {
    closeModal($cancelModal);
  });

  $(document).on("click", "#reservation_cancelBtn", function () {
    disabledTurboElements();
    closeModal($cancelModal);
  });

  // ユーザーキャンセルモーダルのイベントリスナー（キャンセル欄用）
  $("#closeUserCancelModal, #cancelUserCancelModalBtn").on("click", function () {
    closeModal($userCancelModal);
  });

  $(document).on("click", "#userCancelBtn", function () {
    disabledTurboElements();
    $loadingOverlay.css("display", "flex");
    closeModal($userCancelModal);
  });

  document.addEventListener("turbo:submit-end", function (event) {
    if (event.target.id === "userCancelForm") {
      hideLoadingOverlay();
    }
  });

  // モーダル外をクリックした時の処理
  $(window).on("click", function (e) {
    if (e.target === $approveModal[0]) closeModal($approveModal);
    if (e.target === $cancelModal[0]) closeModal($cancelModal);
    if (e.target === $userCancelModal[0]) closeModal($userCancelModal);
  });
}

// ページ読み込み時にモーダルを初期化
$(document).on("turbo:load", function () {
  initializeReservationModals();
});

// 予約カレンダー関連の機能
function initializeReservationCalendar() {
  // 日付予約表示モーダルの制御
  function showDateReservations(date) {
    const $modal = $("#dateReservationsModal");
    const $modalTitle = $("#modalDateTitle");
    const $reservationsList = $("#modalReservationsList");

    if (!$modal.length || !$modalTitle.length || !$reservationsList.length) {
      return;
    }

    // 日付を日本語形式で表示
    const dateObj = new Date(date);
    const formattedDate = dateObj.getFullYear() + "年" + (dateObj.getMonth() + 1) + "月" + dateObj.getDate() + "日";
    $modalTitle.text(formattedDate + "の予約");

    // ローディング表示
    $reservationsList.html('<div class="loading">読み込み中...</div>');
    $modal.css("display", "flex");

    // APIから予約情報を取得
    fetchDateReservations(date, $reservationsList);
  }

  function closeDateReservationsModal() {
    const $modal = $("#dateReservationsModal");
    if ($modal.length) {
      $modal.css("display", "none");
    }
  }

  function fetchDateReservations(date, $container) {
    // プルダウンからスタジオとルームのパラメータを取得
    const studioSelected = $("#reservation_filter_studio").find('option:selected');
    const roomSelected = $("#reservation_filter_room").find('option:selected');
    const studio = studioSelected.data('studio');
    const room = roomSelected.data('room');

    // APIエンドポイントを構築
    const apiUrl = `/studio/reservations/date/${date}?studio=${studio || ""}&room=${room || ""}`;

    $.ajax({
      url: apiUrl,
      method: "GET",
      dataType: "json",
      headers: {
        "X-Requested-With": "XMLHttpRequest",
      },
    })
      .done(function (data) {
        displayDetailedReservations(data.reservations, $container);
      })
      .fail(function (jqXHR, textStatus, errorThrown) {
        console.error("Error fetching reservations:", errorThrown);
        $container.html('<p class="error">予約情報の取得に失敗しました。</p>');
      });
  }

  function displayDetailedReservations(reservations, $container) {
    if (reservations.length === 0) {
      $container.html('<p class="no-reservations">この日付の予約はありません。</p>');
      return;
    }

    let html = '<div class="reservations-list">';
    reservations.forEach(function (reservation) {
      const statusClass = getStatusClass(reservation.reserve_status);
      const statusText = getStatusText(reservation.reserve_status);

      html += `
        <div class="reservation-item">
          <div class="reservation-time">
            <div class="time-range">${reservation.start_time} - ${reservation.end_time}</div>
          </div>
          <div class="reservation-details">
            <div class="reservation-name">${reservation.user_name}</div>
            <div class="reservation-room">${reservation.studio_name} / ${reservation.room_name}</div>
            <div class="reservation-status ${statusClass}">${statusText}</div>
            <div class="reservation-amount">${reservation.amount}円</div>
          </div>
        </div>
      `;
    });
    html += "</div>";

    $container.html(html);
  }

  function getStatusClass(status) {
    const statusMap = {
      pending: "status-pending",
      confirming: "status-confirming",
      approved: "status-approved",
      user_canceled: "status-user-canceled",
      studio_canceled: "status-studio-canceled",
      studio_matter_canceled: "status-studio-matter-canceled",
    };
    return statusMap[status] || "status-default";
  }

  function getStatusText(status) {
    const statusMap = {
      pending: "予約処理中",
      confirming: "確認待ち",
      approved: "承認",
      user_canceled: "ユーザキャンセル",
      studio_canceled: "スタジオキャンセル",
      studio_matter_canceled: "スタジオ都合キャンセル",
    };
    return statusMap[status] || status;
  }

  // グローバル関数として公開（HTMLから呼び出し可能）
  window.showDateReservations = showDateReservations;
  window.closeDateReservationsModal = closeDateReservationsModal;

  // モーダル外クリックで閉じる
  $(document).on("click", "#dateReservationsModal", function (event) {
    if (event.target === this) {
      $(this).css("display", "none");
    }
  });
}

// ページ読み込み時に予約カレンダー機能を初期化
$(document).on("turbo:load", function () {
  initializeReservationCalendar();
});

// ========== 記事順序管理機能 ==========
// グローバル変数
let articleOrderInitialized = false;
let articleCards = null;
let confirmOrderBtn = null;
let resetOrderBtn = null;
let orderChangeWarning = null;
let hasChanges = false;
let originalOrder = [];
let pendingNavigationUrl = null;
let lastPointerDownTarget = null;

// 初期状態を保存
function saveOriginalOrder() {
  if (!articleCards) return;
  originalOrder = Array.from(articleCards.children).map((card) => ({
    uuid: card.dataset.uuid,
    position: parseInt(card.dataset.position),
  }));
}

// カードの順序を更新
function updateCardOrder() {
  if (!articleCards) return;
  const cards = Array.from(articleCards.children);
  cards.forEach((card, index) => {
    card.dataset.position = index;

    // 表示順の番号を更新
    const orderElement = card.querySelector(".admin_articleCardOrder");
    if (orderElement) {
      orderElement.textContent = index + 1;
    }
  });

  // 矢印ボタンの表示/非表示を更新
  updateArrowButtons();

  // 変更があったかチェック
  checkForChanges();
}

// 矢印ボタンの表示/非表示を更新
function updateArrowButtons() {
  if (!articleCards) return;
  const cards = Array.from(articleCards.children);
  const totalCards = cards.length;

  cards.forEach((card, index) => {
    const leftArrow = card.querySelector(".admin_articleArrowLeft");
    const rightArrow = card.querySelector(".admin_articleArrowRight");

    // 最初のカード：右矢印のみ表示
    // 最後のカード：左矢印のみ表示
    // 真ん中のカード：両方表示
    if (leftArrow) {
      leftArrow.style.display = index === 0 ? "none" : "flex";
    }
    if (rightArrow) {
      rightArrow.style.display = index === totalCards - 1 ? "none" : "flex";
    }
  });
}

// 変更があったかチェック
function checkForChanges() {
  if (!articleCards || !confirmOrderBtn) return;
  hasChanges = false;

  // すべてのカードをチェックして、positionが変わったものにクラスを付与
  Array.from(articleCards.children).forEach((card, currentIndex) => {
    const uuid = card.dataset.uuid;
    const originalItem = originalOrder.find((o) => o.uuid === uuid);
    const cardContent = card.querySelector(".admin_articleCardContent");

    if (!cardContent) return;

    if (originalItem) {
      const originalPosition = originalItem.position;
      // 現在の位置と元の位置を比較
      if (originalPosition !== currentIndex) {
        // positionが変わった場合はクラスを付与
        cardContent.classList.add("admin_articleCardChanged");
        hasChanges = true;
      } else {
        // positionが元に戻った場合はクラスを除却
        cardContent.classList.remove("admin_articleCardChanged");
      }
    }
  });

  // ボタンと警告メッセージの表示を更新
  confirmOrderBtn.disabled = !hasChanges;

  if (resetOrderBtn) {
    resetOrderBtn.style.display = hasChanges ? "inline-block" : "none";
  }

  if (orderChangeWarning) {
    orderChangeWarning.style.display = hasChanges ? "block" : "none";
  }

  // 編集・削除ボタンの有効/無効を切り替え
  updateActionButtonsState();
}

// 編集・削除・追加ボタン、入力欄の有効/無効を切り替え
function updateActionButtonsState() {
  if (!articleCards) return;

  const editButtons = document.querySelectorAll(".admin_articleCardEdit");
  const deleteButtons = document.querySelectorAll(".admin_articleCardDelete");
  const addArticleBtn = document.getElementById("addArticleBtn");
  const newArticleTitle = document.getElementById("newArticleTitle");
  const newArticleUrl = document.getElementById("newArticleUrl");
  const newArticleThumbnail = document.getElementById("newArticleThumbnail");

  editButtons.forEach((button) => {
    button.disabled = hasChanges;
  });

  deleteButtons.forEach((button) => {
    button.disabled = hasChanges;
  });

  if (addArticleBtn) {
    addArticleBtn.disabled = hasChanges;
  }

  // 新規記事追加フォームの入力欄も無効化
  if (newArticleTitle) {
    newArticleTitle.disabled = hasChanges;
  }

  if (newArticleUrl) {
    newArticleUrl.disabled = hasChanges;
  }

  if (newArticleThumbnail) {
    newArticleThumbnail.disabled = hasChanges;
  }
}

// 元の順序に戻す
function resetOrder() {
  if (!articleCards || originalOrder.length === 0) return;

  // originalOrderの順序でカードをソート
  const sortedCards = originalOrder
    .map((item) => {
      return Array.from(articleCards.children).find((card) => card.dataset.uuid === item.uuid);
    })
    .filter((card) => card !== undefined);

  // カードを順番に追加し直す
  sortedCards.forEach((card) => {
    articleCards.appendChild(card);
  });

  // 変更クラスを全て削除
  Array.from(articleCards.children).forEach((card) => {
    const cardContent = card.querySelector(".admin_articleCardContent");
    if (cardContent) {
      cardContent.classList.remove("admin_articleCardChanged");
    }
  });

  // 状態を更新
  updateCardOrder();
}

// カードを移動
function moveCard(card, direction) {
  if (!articleCards) return;
  const currentIndex = Array.from(articleCards.children).indexOf(card);
  const newIndex = direction === "left" ? currentIndex - 1 : currentIndex + 1;

  if (newIndex >= 0 && newIndex < articleCards.children.length) {
    if (direction === "left") {
      articleCards.insertBefore(card, articleCards.children[newIndex]);
    } else {
      articleCards.insertBefore(card, articleCards.children[newIndex + 1]);
    }

    updateCardOrder();
  }
}

// 編集モーダルを開く
function openEditModal(uuid) {
  // 記事データを取得してモーダルに設定
  const card = document.querySelector(`[data-uuid="${uuid}"]`);
  if (!card) return;

  const thumbnail = card.querySelector(".admin_articleCardImage");
  const noImageDiv = card.querySelector(".admin_articleCardNoImage");
  const title = thumbnail ? thumbnail.alt : noImageDiv ? noImageDiv.textContent.trim() : "";
  const url = card.querySelector(".admin_articleCardUrl").dataset.url;

  document.getElementById("editUuid").value = uuid;
  document.getElementById("editTitle").value = title;
  document.getElementById("editUrl").value = url;

  // 現在のサムネイル画像を表示
  const currentThumbnailDiv = document.getElementById("currentThumbnail");
  const newThumbnailPreview = document.getElementById("newThumbnailPreview");

  if (thumbnail) {
    currentThumbnailDiv.innerHTML = `
      <div class="thumbnail-preview current">
        <p class="preview-label current-label">現在の画像：</p>
        <img src="${thumbnail.src}" alt="${title}">
      </div>
    `;
  } else {
    currentThumbnailDiv.innerHTML = `
      <div class="thumbnail-preview empty">
        <p class="preview-label empty-label">現在の画像：なし</p>
      </div>
    `;
  }

  // 新しいプレビューをクリア
  newThumbnailPreview.innerHTML = "";

  // ファイル入力をリセット
  document.getElementById("editThumbnail").value = "";

  document.getElementById("editModal").style.display = "block";
}

// 削除モーダルを開く
function openDeleteModal(uuid) {
  const card = document.querySelector(`[data-uuid="${uuid}"]`);
  if (!card) return;

  const thumbnail = card.querySelector(".admin_articleCardImage");
  const noImageDiv = card.querySelector(".admin_articleCardNoImage");
  const title = thumbnail ? thumbnail.alt : noImageDiv ? noImageDiv.textContent.trim() : "";
  const url = card.querySelector(".admin_articleCardUrl").dataset.url;

  const deleteInfo = document.getElementById("deleteArticleInfo");
  deleteInfo.innerHTML = `
    <div class="delete-article-preview">
      <div class="delete-article-thumbnail">
        ${thumbnail ? `<img src="${thumbnail.src}" alt="${title}" style="width: 100%; max-width: 200px; border-radius: 4px;">` : '<div class="empty-thumbnail">画像なし</div>'}
      </div>
      <div class="delete-article-info">
        <h4>${title}</h4>
        <p><strong>URL:</strong> <a href="${url}" target="_blank">${url}</a></p>
      </div>
    </div>
    <div class="delete-warning">
      <strong>⚠️ この記事を本当に削除しますか？</strong><br>
      この操作は取り消すことができません。
    </div>
  `;

  document.getElementById("confirmDelete").onclick = function () {
    deleteArticle(uuid);
  };

  document.getElementById("deleteModal").style.display = "block";
}

// 記事削除
function deleteArticle(uuid) {
  const card = document.querySelector(`[data-uuid="${uuid}"]`);
  if (!card) return;

  const deleteButton = card.querySelector(".admin_articleCardDelete");
  const deleteUrl = deleteButton.dataset.deleteUrl || `/admin/articles/${uuid}`;

  fetch(deleteUrl, {
    method: "DELETE",
    headers: {
      "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').getAttribute("content"),
      Accept: "application/json",
    },
  })
    .then((response) => response.json())
    .then((data) => {
      if (data.status === "success") {
        closeDeleteModal();
        // 成功時は変更フラグをクリアしてからページをリロード
        hasChanges = false;
        window.location.reload();
      } else {
        console.error("Error data:", data);
        alert("エラーが発生しました: " + (data.message || "不明なエラー"));
      }
    })
    .catch((error) => {
      console.error("Error:", error);
      alert("エラーが発生しました: " + error.message);
    });
}

// モーダルを閉じる
window.closeEditModal = function () {
  document.getElementById("editModal").style.display = "none";
};

window.closeDeleteModal = function () {
  document.getElementById("deleteModal").style.display = "none";
};

// ページ遷移確認モーダルを開く
function openNavigationConfirmModal(url) {
  pendingNavigationUrl = url;
  document.getElementById("navigationConfirmModal").style.display = "block";
}

// ページ遷移確認モーダルを閉じる
function closeNavigationConfirmModal() {
  pendingNavigationUrl = null;
  document.getElementById("navigationConfirmModal").style.display = "none";
}

// イベントリスナーを設定（一度だけ実行）
function setupEventListeners() {
  if (articleOrderInitialized) return;

  window.addEventListener("pointerdown", function (event) {
    lastPointerDownTarget = event.target;
  });

  // 矢印ボタンのイベントリスナー
  document.addEventListener("click", function (e) {
    // 記事カード内の矢印ボタン
    if (e.target.closest(".admin_articleArrow")) {
      e.preventDefault();
      const arrow = e.target.closest(".admin_articleArrow");
      const card = arrow.closest(".admin_articleCard");
      const direction = arrow.dataset.direction;

      if (card && articleCards && articleCards.contains(card)) {
        moveCard(card, direction);
      }
    }

    // URLボタン
    if (e.target.closest(".admin_articleCardUrl")) {
      e.preventDefault();
      const button = e.target.closest(".admin_articleCardUrl");
      const url = button.dataset.url;
      if (url) {
        window.open(url, "_blank", "noopener,noreferrer");
      }
    }

    // 編集ボタン
    if (e.target.closest(".admin_articleCardEdit")) {
      e.preventDefault();
      const button = e.target.closest(".admin_articleCardEdit");
      if (button.disabled || hasChanges) return; // 無効化されている場合は処理しない
      const uuid = button.dataset.uuid;
      openEditModal(uuid);
    }

    // 削除ボタン
    if (e.target.closest(".admin_articleCardDelete")) {
      e.preventDefault();
      const button = e.target.closest(".admin_articleCardDelete");
      if (button.disabled || hasChanges) return; // 無効化されている場合は処理しない
      const uuid = button.dataset.uuid;
      openDeleteModal(uuid);
    }
  });

  // 変更を破棄ボタンのイベントリスナー
  document.addEventListener("click", function (e) {
    if (e.target.id === "resetOrder" || e.target.closest("#resetOrder")) {
      e.preventDefault();
      resetOrder();
    }
  });

  // 表示順確定ボタンのイベントリスナー
  document.addEventListener("click", function (e) {
    if (e.target.id === "confirmOrder" || e.target.closest("#confirmOrder")) {
      e.preventDefault();
      if (!hasChanges || !articleCards || !confirmOrderBtn) return;

      const positions = Array.from(articleCards.children).map((card, index) => ({
        uuid: card.dataset.uuid,
        position: index,
      }));

      const updatePositionsUrl = confirmOrderBtn.dataset.updatePositionsUrl || "/admin/articles/update_positions";

      fetch(updatePositionsUrl, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').getAttribute("content"),
          Accept: "application/json",
        },
        body: JSON.stringify({ positions: positions }),
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.status === "success") {
            // 成功時は変更フラグをクリアしてからページをリロード
            hasChanges = false;
            window.location.reload();
          } else {
            console.error("Error data:", data);
            alert("エラーが発生しました: " + (data.message || "不明なエラー"));
          }
        })
        .catch((error) => {
          console.error("Error:", error);
          alert("エラーが発生しました: " + error.message);
        });
    }
  });

  // ページ離脱時の警告
  window.addEventListener("beforeunload", function (e) {
    if (hasChanges) {
      e.preventDefault();
      e.returnValue = "";
    }
  });

  // 編集モーダルのサムネイルファイル選択時のプレビュー
  const editThumbnailInput = document.getElementById("editThumbnail");
  if (editThumbnailInput) {
    editThumbnailInput.addEventListener("change", function (e) {
      const file = e.target.files[0];
      const newThumbnailPreview = document.getElementById("newThumbnailPreview");

      if (file) {
        const reader = new FileReader();
        reader.onload = function (e) {
          newThumbnailPreview.innerHTML = `
            <div class="thumbnail-preview new">
              <p class="preview-label new-label">✓ 新しく選択された画像：</p>
              <img src="${e.target.result}" alt="新しいサムネイル">
              <p class="file-name">ファイル名: ${file.name}</p>
            </div>
          `;
        };
        reader.readAsDataURL(file);
      } else {
        newThumbnailPreview.innerHTML = "";
      }
    });
  }

  // 編集フォーム送信
  const editForm = document.getElementById("editForm");
  if (editForm) {
    editForm.addEventListener("submit", function (e) {
      e.preventDefault();

      const formData = new FormData(this);
      const uuid = formData.get("uuid");
      const card = document.querySelector(`[data-uuid="${uuid}"]`);
      if (!card) return;

      const editButton = card.querySelector(".admin_articleCardEdit");
      const editUrl = editButton.dataset.editUrl || `/admin/articles/${uuid}`;

      fetch(editUrl, {
        method: "PATCH",
        headers: {
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').getAttribute("content"),
          Accept: "application/json",
        },
        body: formData,
      })
        .then((response) => {
          if (response.ok) {
            closeEditModal();
            // 編集成功時は変更フラグをクリアしてからページをリロード
            hasChanges = false;
            window.location.reload();
          } else {
            return response
              .json()
              .then((data) => {
                console.error("Error response:", data);
                const errorMessage = data.errors ? data.errors.join("\n") : "更新に失敗しました";
                alert(`更新に失敗しました:\n${errorMessage}`);
              })
              .catch(() => {
                alert(`更新に失敗しました (ステータス: ${response.status})`);
              });
          }
        })
        .catch((error) => {
          console.error("Error:", error);
          alert("エラーが発生しました: " + error.message);
        });
    });
  }

  // モーダルの外側クリックで閉じる
  window.addEventListener("click", function (event) {
    const editModal = document.getElementById("editModal");
    const deleteModal = document.getElementById("deleteModal");
    const navigationConfirmModal = document.getElementById("navigationConfirmModal");

    const startedOnOverlay = function (modal) {
      return modal && lastPointerDownTarget === modal;
    };

    if (event.target === editModal && startedOnOverlay(editModal)) {
      closeEditModal();
    }
    if (event.target === deleteModal && startedOnOverlay(deleteModal)) {
      closeDeleteModal();
    }
    if (event.target === navigationConfirmModal && startedOnOverlay(navigationConfirmModal)) {
      closeNavigationConfirmModal();
    }
    lastPointerDownTarget = null;
  });

  // ページ遷移確認モーダルのボタンイベント
  const cancelNavigationBtn = document.getElementById("cancelNavigation");
  const confirmNavigationBtn = document.getElementById("confirmNavigation");

  if (cancelNavigationBtn) {
    cancelNavigationBtn.addEventListener("click", function () {
      closeNavigationConfirmModal();
    });
  }

  if (confirmNavigationBtn) {
    confirmNavigationBtn.addEventListener("click", function () {
      if (pendingNavigationUrl) {
        hasChanges = false; // 変更フラグをクリアして遷移を許可
        window.location.href = pendingNavigationUrl;
      }
    });
  }

  // すべてのリンクに対してクリックイベントリスナーを追加
  document.addEventListener(
    "click",
    function (e) {
      // aタグまたはその子要素がクリックされた場合
      const link = e.target.closest("a");
      if (link && hasChanges) {
        // 外部リンクや特定の属性を持つリンクは除外
        const href = link.getAttribute("href");
        if (href && !href.startsWith("#") && !href.startsWith("javascript:") && !link.hasAttribute("data-method") && !link.hasAttribute("data-turbo-method")) {
          e.preventDefault();
          openNavigationConfirmModal(href);
        }
      }
    },
    true
  ); // キャプチャフェーズで実行

  articleOrderInitialized = true;
}

// 初期化関数
function initializeArticleOrder() {
  articleCards = document.getElementById("articleCards");
  confirmOrderBtn = document.getElementById("confirmOrder");
  resetOrderBtn = document.getElementById("resetOrder");
  orderChangeWarning = document.getElementById("orderChangeWarning");

  if (!articleCards || !confirmOrderBtn) {
    return; // 要素がない場合は処理を中断
  }

  // イベントリスナーを設定（一度だけ）
  setupEventListeners();

  // 状態を更新
  hasChanges = false;
  saveOriginalOrder();
  updateArrowButtons();
  checkForChanges(); // 初期状態でボタンと警告を非表示にする
}

// DOMContentLoadedイベントとturbo:loadイベントの両方で初期化
document.addEventListener("DOMContentLoaded", initializeArticleOrder);
document.addEventListener("turbo:load", initializeArticleOrder);

// スタジオページのheader横スクロール対応
function handleStudioHeaderScroll() {
  const stHeader = document.querySelector('.stHeader');
  
  if (!stHeader) {
    return; // stHeaderが存在しない場合は処理を中断
  }
  
  // 横スクロール時にheaderの位置を調整
  const handleScroll = () => {
    const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
    stHeader.style.left = -scrollLeft + 'px';
  };
  
  // スクロールイベントリスナーを追加
  window.addEventListener('scroll', handleScroll);
  
  // 初期位置を設定
  handleScroll();
}

document.addEventListener("turbo:load", handleStudioHeaderScroll);
document.addEventListener("DOMContentLoaded", handleStudioHeaderScroll);

// ===========================
// 空室カレンダー
// ===========================
let _calendarSelectHandler = null;
let _calendarUpdateEndHandler = null;
let reservationCalendarData = null;
let selectedDateDailyData = null;
let calendarSlotData = null;
let isLoadingCalendar = false;
let lastRequestMonth = null;
let pendingMonth = null;
// ユーザーが選んだプラン（pu）。未選択なら null で、その場合は自動選択（最安・優先度順）に従う。
// 日時を変えたとき、選んだプランが候補に残っていれば維持し、外れていれば null に戻す。
let userSelectedPu = null;

const clearCalendarVariables = () => {
  if (_calendarSelectHandler) {
    document.removeEventListener("calendar:select-date", _calendarSelectHandler);
  }
  _calendarSelectHandler = null;
  if (_calendarUpdateEndHandler) {
    document.removeEventListener("calendar:update-end", _calendarUpdateEndHandler);
  }
  _calendarUpdateEndHandler = null;
  reservationCalendarData = null;
  selectedDateDailyData = null;
  calendarSlotData = null;
  isLoadingCalendar = false;
  lastRequestMonth = null;
  pendingMonth = null;
  userSelectedPu = null;
};

const initCalendar = () => {
  let initializing = true;

  // セレクションエリア本体
  const selectionArea = document.getElementById("calendar_selection_area");
  if (!selectionArea) return;

  // セレクションエリア内利用時間選択部
  const timeSelectTitle = document.getElementById("time_select_title");
  const startTimeSelect = document.getElementById("calendar_start_time");
  const endTimeSelect = document.getElementById("calendar_end_time");

  // セレクションエリア内情報表示部＆予約ボタン
  const feeArea = document.getElementById("calendar_fee_area");
  const initialMsg = document.getElementById("calendar_initial_message");
  const dateDisplay = document.getElementById("selected_date_display");
  const summaryTimeDisplay = document.getElementById("summary_datetime");
  const totalFeeDisplay = document.getElementById("calendar_total_fee");
  const reserveBtn = document.getElementById("calendar_reserve_button");

  // ページ下部情報表示部＆予約ボタン
  const bottomDateDisplay = document.getElementById("bottom_selected_date");
  const bottomTimeDisplay = document.getElementById("bottom_selected_time");
  const bottomFeeDisplay = document.getElementById("bottom_total_fee");
  // 直前割（割引後の金額のときだけ出す）。金額の正はサーバーの予約時の計算で、ここは表示だけ
  const lastMinuteBadge = document.getElementById("calendar_last_minute_badge");
  const originalFeeDisplay = document.getElementById("calendar_original_fee");
  const bottomLastMinuteBadge = document.getElementById("bottom_last_minute_badge");
  const bottomReserveBtn = document.getElementById("bottom_reserve_button");

  // カレンダー月表示部＆月切り替えボタン
  const calendarMonthDisplay = document.getElementById("calendar_current_month");
  const calendarNavPrev = document.getElementById("calendar_nav_prev");
  const calendarNavNext = document.getElementById("calendar_nav_next");

  // カレンダーグリッドラッパー（ローディング表示用）
  const calendarGridWrapper = document.getElementById("calendar_grid_wrapper");

  const formatTime = (hour, minute) => {
    const hourStr = (hour >= 24) ? "翌" + String(hour % 24).padStart(2, "0") : String(hour).padStart(2, "0");
    const minuteStr = String(minute).padStart(2, "0");
    return `${hourStr}:${minuteStr}`;
  };

  const toMinutes = (hour, minute) => {
    const numHour = parseInt(hour, 10);
    const numMinute = parseInt(minute, 10);
    if (isNaN(numHour) || isNaN(numMinute)) return null;
    return numHour * 60 + numMinute;
  };

  const slotTimeStr = (slotTime) => {
    const h = Math.floor(slotTime / 60);
    const m = slotTime % 60;
    return formatTime(h, m);
  };

  const slotTime = (slot, slotMinutes) => {
    const numSlot = parseInt(slot, 10);
    if (isNaN(numSlot)) return null;
    return numSlot * slotMinutes;
  };

  const weekdayStr = (day, isHoliday) => {
    let weekday;
    switch (day) {
      case 0: weekday = "日"; break;
      case 1: weekday = "月"; break;
      case 2: weekday = "火"; break;
      case 3: weekday = "水"; break;
      case 4: weekday = "木"; break;
      case 5: weekday = "金"; break;
      case 6: weekday = "土"; break;
      default: return "";
    }

    const holiday = isHoliday ? "・祝" : "";

    return `(${weekday}${holiday})`
  };

  const minRentalHours = (minRentalMinutes, slotMinutes) => {
    const minSlotMinutes = minRentalMinutes > 0
      ? (Math.floor((minRentalMinutes - 1) / slotMinutes) + 1) * slotMinutes
      : slotMinutes;
    return minSlotMinutes / 60;
  };

  const urlParams = new URLSearchParams(window.location.search);
  const initialStartHour = urlParams.get('start_hour');
  const initialStartMinute = urlParams.get('start_minute');
  const initialEndHour = urlParams.get('end_hour');
  const initialEndMinute = urlParams.get('end_minute');
  const initialStartTime = (initialStartHour && initialStartMinute) ? toMinutes(initialStartHour, initialStartMinute) : null;
  const initialEndTime = (initialEndHour && initialEndMinute)
    ? (initialStartTime && initialStartTime >= toMinutes(initialEndHour, initialEndMinute))
      ? toMinutes(initialEndHour, initialEndMinute) + 24 * 60
      : toMinutes(initialEndHour, initialEndMinute)
    : null;
  let lastSelectedStartTime = null;
  let lastSelectedEndTime = null;

  const reduceRsaDataForStartTime = (rsa) => {
    const minKey = "minMinRentalMinutes";
    const maxKey = "maxMinRentalMinutes";

    return rsa.reduce((acc, obj) => {
      Object.keys(obj).forEach((key) => {
        if (/^\d+$/.test(key)) {
          acc[key] = Math.max((typeof acc[key] !== 'undefined' ? acc[key] : -1), obj[key]);
          if (obj[key] >= 0) {
            const minRentalMinutes = obj.minRentalMinutes;
            acc[minKey] = Math.min((typeof acc[minKey] !== 'undefined' ? acc[minKey] : minRentalMinutes), minRentalMinutes);
            acc[maxKey] = Math.max((typeof acc[maxKey] !== 'undefined' ? acc[maxKey] : minRentalMinutes), minRentalMinutes);
          }
        }
      });

      return acc;
    }, {});
  };

  const reduceRsaDataForEndTime = (rsa, key, slotMinutes, slotsPerDay) => {
    if (!/^\d+$/.test(key)) return {};

    const startSlot = Number(key);

    return rsa.reduce((acc, obj) => {
      const val = obj[key];
      if (val > 0) {
        const minRentalMinutes = obj.minRentalMinutes;
        const requiredSlotSize = minRentalMinutes > 0 ? Math.floor(((minRentalMinutes - 1) / slotMinutes) + 1) : 1;
        const start = Math.max(startSlot + requiredSlotSize, 1);
        const last = Math.min(startSlot + val, slotsPerDay);
        for (let i = start; i <= last; i += 1) {
          acc[i] = i;
        }
      }

      return acc;
    }, {});
  };

  const generateStartTimeOptions = (reducedRsa, slotMinutes) => {
    const slotNumPerDay = 24 * 60 / slotMinutes;
    const options = [];

    Object.keys(reducedRsa).forEach((key) => {
      if (/^\d+$/.test(key) && Number(key) < slotNumPerDay) {
        const val = reducedRsa[key];
        if (val >= 0) {
          const t = slotTime(Number(key), slotMinutes);
          const timeStr = slotTimeStr(t);
          const reserved = (val === 0);

          options.push({
            value: key,
            text: reserved ? `${timeStr} (利用不可)` : timeStr,
            disabled: reserved
          });
        }
      }
    });

    return options;
  };

  const generateEndTimeOptions = (reducedRsa, slotMinutes) => {
    const options = [];

    Object.keys(reducedRsa).forEach((key) => {
      if (/^\d+$/.test(key)) {
        const t = slotTime(Number(key), slotMinutes);

        options.push({
          value: key,
          text: slotTimeStr(t)
        });
      }
    });

    return options;
  };

  const calcBaseFee = (rsa, rsp, startSlot, endSlot, slotMinutes) => {
    const validPuList = findValidPus(rsa, startSlot, endSlot, slotMinutes);

    return findBestFeeData(validPuList, rsp, startSlot, endSlot);
  };

  // その日時で予約できるプランを全部返す。
  // これまで findBestFeeData が1つに潰していた候補を、捨てずに使うための関数。
  //
  // ⚠️ 優先度が劣るプランは候補から外す。
  //    祝日には「土日祝」プランが priority=holiday(1)、「平日」プランが normal(2) になる。
  //    平日プランを候補に残すと、利用者が祝日に平日料金を選べてしまう。
  const calcAllFeeData = (rsa, rsp, startSlot, endSlot, slotMinutes) => {
    const validPuList = findValidPus(rsa, startSlot, endSlot, slotMinutes);

    const candidates = validPuList.reduce((acc, pu) => {
      const matchingRsp = rsp.find(data => data.pu === pu);
      if (!matchingRsp) return acc;

      const feePriority = calcPlanFeeAndPriority(matchingRsp, startSlot, endSlot);
      if (!feePriority) return acc;

      acc.push(feePriority);
      return acc;
    }, []);

    if (candidates.length < 2) return candidates;

    const bestPriority = candidates.reduce(
      (min, c) => (Number(c.priority) < min ? Number(c.priority) : min),
      Number(candidates[0].priority)
    );

    return candidates.filter(c => Number(c.priority) === bestPriority);
  };

  // いま選べるプランの候補。モーダルを開いたときに使う。
  let currentPlanCandidates = [];
  let currentSelectedPu = null;

  const planLabel = (pu) => {
    const plan = planOptionMap()[pu];
    return plan ? plan.name : "プラン";
  };

  // 予約パネルの「選択中のプラン」を描く。
  // 候補が1つでも名前は出す。2つ以上あるときだけ「変更する」を出す。
  const renderPlanSelection = (candidates, selected) => {
    const row = document.getElementById("calendar_plan_row");
    const label = document.getElementById("calendar_selected_plan");
    const changeBtn = document.getElementById("calendar_plan_change");
    if (!row || !label || !changeBtn) return;

    currentPlanCandidates = candidates;

    if (!selected) {
      row.hidden = true;
      changeBtn.hidden = true;
      return;
    }

    currentSelectedPu = selected.pu;
    label.textContent = planLabel(selected.pu);
    row.hidden = false;
    changeBtn.hidden = candidates.length < 2;
  };

  const closePlanModal = () => {
    const modal = document.getElementById("planSelectModal");
    if (modal) modal.hidden = true;
  };

  // 候補になっていないプランは出さない。グレーアウトもしない。
  const openPlanModal = (selectedPu) => {
    const modal = document.getElementById("planSelectModal");
    const list = document.getElementById("planSelectModalList");
    if (!modal || !list) return;

    const map = planOptionMap();
    list.innerHTML = "";

    currentPlanCandidates.forEach((candidate) => {
      const plan = map[candidate.pu] || {};
      const item = document.createElement("li");
      item.className = "priceSection_card" + (candidate.pu === selectedPu ? " is-selected" : "");
      item.innerHTML =
        '<p class="priceSection_cardName"></p>' +
        '<p class="priceSection_cardFee"></p>' +
        '<p class="priceSection_cardCondition"></p>' +
        '<button type="button" class="priceSection_cardButton" data-plan-select="1"></button>';
      item.querySelector(".priceSection_cardName").textContent = plan.name || "プラン";
      item.querySelector(".priceSection_cardFee").textContent = "¥" + Number(candidate.fee).toLocaleString();
      item.querySelector(".priceSection_cardCondition").textContent =
        [plan.condition, plan.minRentalLabel].filter(Boolean).join(" / ");
      const btn = item.querySelector(".priceSection_cardButton");
      btn.dataset.planPu = candidate.pu;
      btn.textContent = candidate.pu === selectedPu ? "選択中" : "このプランにする";
      list.appendChild(item);
    });

    modal.hidden = false;
  };

  // 表示用のプラン情報（pu -> 名前・条件）。カレンダーJSONとは別に埋め込んである。
  const planOptionMap = () => {
    const el = document.getElementById("plan_options");
    if (!el || !el.dataset.plans) return {};

    try {
      return JSON.parse(el.dataset.plans).reduce((acc, plan) => {
        acc[plan.pu] = plan;
        return acc;
      }, {});
    } catch (e) {
      return {};
    }
  };

  const findValidPus = (rsa, startSlot, endSlot, slotMinutes) => {
    const reserveSlotSize = endSlot - startSlot;

    return rsa.reduce((acc, obj) => {
      const minRentalMinutes = obj.minRentalMinutes;
      const requiredSlotSize = minRentalMinutes > 0 ? Math.floor(((minRentalMinutes - 1) / slotMinutes) + 1) : 1;

      if (reserveSlotSize < requiredSlotSize) return acc;
      if (obj[startSlot] < reserveSlotSize) return acc;

      acc.push(obj.pu);

      return acc;
    }, []);
  };

  const findBestFeeData = (validPuList, rsp, startSlot, endSlot) => {
    let best = null;

    for (let i = 0; i < validPuList.length; i += 1) {
      const pu = validPuList[i];
      const matchingRsp = rsp.find(data => data.pu === pu);

      if (!matchingRsp) continue;

      const feePriority = calcPlanFeeAndPriority(matchingRsp, startSlot, endSlot);

      if (!feePriority) continue;

      if (
        !best ||
        feePriority.priority < best.priority ||
        (
          feePriority.priority === best.priority &&
          feePriority.fee < best.fee
        )
      ) {
        best = feePriority;
      }
    }

    return best;
  };

  const calcPlanFeeAndPriority = (rsp, startSlot, endSlot) => {
    let totalFee = 0;
    let originalFee = 0;
    let lastMinute = false;
    let minPriority = null;

    for (let i = startSlot; i < endSlot; i += 1) {
      const data = rsp[i];

      if (!data || Object.keys(data).length === 0) {
        return null;
      }

      totalFee += Number(data.price);
      originalFee += Number(data.basePrice !== undefined ? data.basePrice : data.price);
      if (data.lastMinute) lastMinute = true;
      minPriority = minPriority !== null ? Math.min(minPriority, data.priority) : data.priority;
    }

    totalFee = Math.round(totalFee);
    originalFee = Math.round(originalFee);

    return { fee: totalFee, originalFee: originalFee, lastMinute: lastMinute, priority: minPriority, pu: rsp.pu };
  };

  const showErrorMessage = (msg) => {
    let errorBox = document.getElementById("calendar_error_message");
    if (!errorBox) {
      errorBox = document.createElement("div");
      errorBox.id = "calendar_error_message";
      errorBox.style.color = "red";
      errorBox.style.padding = "10px";
      errorBox.style.textAlign = "center";
      errorBox.style.fontWeight = "bold";
      selectionArea.insertBefore(errorBox, selectionArea.firstChild);
    }
    errorBox.textContent = msg;
    errorBox.style.display = "block";
  };
  
  const clearErrorMessage = () => {
    const errorBox = document.getElementById("calendar_error_message");
    if (errorBox) errorBox.style.display = "none";
  };

  const initDateDisplay = () => {
    dateDisplay.textContent = ""
  };

  const initTimeSelectTitle = () => {
    timeSelectTitle.textContent = "利用時間の選択";
  };

  const initStartTimeSelect = (disabled) => {
    startTimeSelect.innerHTML = '<option value="">開始時間</option>';
    startTimeSelect.disabled = disabled;
  };

  const initEndTimeSelect = (disabled) => {
    endTimeSelect.innerHTML = '<option value="">終了時間</option>';
    endTimeSelect.disabled = disabled;
  };

  const renderLastMinute = (feeData, optionsFee) => {
    const on = !!(feeData && feeData.lastMinute && feeData.originalFee > feeData.fee);
    if (lastMinuteBadge) lastMinuteBadge.hidden = !on;
    if (bottomLastMinuteBadge) bottomLastMinuteBadge.hidden = !on;
    if (originalFeeDisplay) {
      originalFeeDisplay.hidden = !on;
      originalFeeDisplay.textContent = on
        ? "¥" + (feeData.originalFee + (optionsFee || 0)).toString(10).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")
        : "";
    }
  };

  const initFeeArea = () => {
    renderLastMinute(null);
    summaryTimeDisplay.textContent = "-";
    totalFeeDisplay.textContent = "-";
    reserveBtn.textContent = "利用時間を選択してください";
    reserveBtn.classList.add("is-disabled");
    reserveBtn.classList.remove("detail_button-active");
    reserveBtn.classList.add("detail_button-inactive");
    if (reserveBtn.tagName === 'A') reserveBtn.href = "#";
  };

  const initBottomArea = () => {
    if (bottomDateDisplay) bottomDateDisplay.textContent = "";
    if (bottomTimeDisplay) {
      bottomTimeDisplay.textContent = "-";
      bottomTimeDisplay.classList.add("is-empty");
    }
    if (bottomFeeDisplay) bottomFeeDisplay.textContent = "-";
    if (bottomReserveBtn) {
      bottomReserveBtn.textContent = "利用時間を選択してください";
      bottomReserveBtn.classList.add("is-disabled");
      bottomReserveBtn.classList.remove("detail_button-active");
      bottomReserveBtn.classList.add("detail_button-inactive");
      if (bottomReserveBtn.tagName === 'A') bottomReserveBtn.href = "#";
    }
  };

  const showBottomArea = () => {
    // オプションの選択エリアを表示
    const optionGuide = document.getElementById("bottom_option_guide");
    if (optionGuide) optionGuide.classList.remove("is-hidden");

    // 選択されている時間・利用料金（税込）エリアを表示
    const timeFeeArea = document.getElementById("bottom_time_fee_area");
    if (timeFeeArea) timeFeeArea.classList.remove("is-hidden");

    // 「空室カレンダーを見る」ボタンのテキストとスタイルを更新
    if (bottomReserveBtn && bottomReserveBtn.textContent.trim() === "空室カレンダーを見る") {
      bottomReserveBtn.textContent = "利用時間を選択してください";
      bottomReserveBtn.classList.add("is-disabled");
      bottomReserveBtn.classList.remove("detail_button-active");
      bottomReserveBtn.classList.add("detail_button-inactive");
      bottomReserveBtn.removeAttribute("onclick");
      if (bottomReserveBtn.tagName === 'A') bottomReserveBtn.href = "#";
    }
  };

  const errorBottomReserveBtn = (btnMsg) => {
    if (bottomReserveBtn) {
      bottomReserveBtn.textContent = btnMsg;
      bottomReserveBtn.classList.add("is-disabled");
      bottomReserveBtn.classList.remove("detail_button-active");
      bottomReserveBtn.classList.add("detail_button-inactive");
      if (bottomReserveBtn.tagName === 'A') bottomReserveBtn.href = "#";
    }
  };

  const showInitialMsg = () => {
    feeArea.style.display = "none";
    initialMsg.style.display = "block";
  };

  const showFeeArea = () => {
    initialMsg.style.display = "none";
    feeArea.style.display = "block";
  };

  const initSelectionArea = () => {
    initDateDisplay();
    initTimeSelectTitle();
    initStartTimeSelect(true);
    initEndTimeSelect(true);
    initFeeArea();
    showInitialMsg();
    clearErrorMessage();
  };

  const initBeforeUpdateStartTimeSelect = () => {
    initTimeSelectTitle();
    initStartTimeSelect(true);
    initEndTimeSelect(true);
    initFeeArea();
    showInitialMsg();
    clearErrorMessage();
  };

  const initBeforeUpdateEndTimeSelect = () => {
    initEndTimeSelect(true);
    initFeeArea();
    showInitialMsg();
    clearErrorMessage();
  };

  const initBeforeUpdateFeeAndButton = () => {
    initFeeArea();
    showInitialMsg();
    clearErrorMessage();
    initBottomArea();
  };

  const updateStartTimeSelect = (date) => {
    initBeforeUpdateStartTimeSelect();

    if (!selectedDateDailyData || selectedDateDailyData.date !== date) {
      selectedDateDailyData = (reservationCalendarData && reservationCalendarData.daily) ? reservationCalendarData.daily.find(data => data.date === date) : null;
    }

    if (!calendarSlotData) {
      calendarSlotData = reservationCalendarData ? reservationCalendarData.slot : null;
    }

    const slotMinutes = calendarSlotData ? calendarSlotData.slotMinutes : null;

    if (!selectedDateDailyData || !slotMinutes) {
      showErrorMessage("システムエラー: カレンダー情報が見つかりませんでした。");
      return;
    }

    const reducedRsa = reduceRsaDataForStartTime(selectedDateDailyData.rsa);

    if (timeSelectTitle && reducedRsa.minMinRentalMinutes && reducedRsa.maxMinRentalMinutes) {
      const minMinRentalHours = minRentalHours(reducedRsa.minMinRentalMinutes, slotMinutes);
      const maxMinRentalHours = minRentalHours(reducedRsa.maxMinRentalMinutes, slotMinutes);

      const minRentalHoursText = (minMinRentalHours != maxMinRentalHours) ? String(minMinRentalHours) + "〜" + String(maxMinRentalHours) : String(minMinRentalHours);
      timeSelectTitle.textContent = `利用時間の選択（最低利用時間は${minRentalHoursText}時間です）`;
    }

    initStartTimeSelect(false);

    const options = generateStartTimeOptions(reducedRsa, slotMinutes);

    if (options.length === 0) {
      startTimeSelect.innerHTML = '<option value="" disabled>予約可能な時間がありません</option>';
    } else {
      options.forEach(opt => {
        const option = document.createElement("option");
        option.value = opt.value;
        option.textContent = opt.text;
        option.disabled = opt.disabled;
        startTimeSelect.appendChild(option);
      });

      const initialSelectedStartTime = lastSelectedStartTime !== null ? lastSelectedStartTime : (initialStartTime !== null ? initialStartTime : null);

      if (initialSelectedStartTime !== null) {
        const matchingStartOption = Array.from(startTimeSelect.options).find(opt => slotTime(opt.value, slotMinutes) === initialSelectedStartTime);
        if (matchingStartOption && !matchingStartOption.disabled) {
          startTimeSelect.value = matchingStartOption.value;
          startTimeSelect.dispatchEvent(new Event('change'));

          const initialSelectedEndTime = lastSelectedEndTime !== null ? lastSelectedEndTime : (initialEndTime !== null ? initialEndTime : null);

          if (initialSelectedEndTime !== null) {
            const matchingEndOption = Array.from(endTimeSelect.options).find(opt => slotTime(opt.value, slotMinutes) === initialSelectedEndTime);
            if (matchingEndOption) {
              endTimeSelect.value = matchingEndOption.value;
              endTimeSelect.dispatchEvent(new Event('change'));
            }
          }
        }
      }
    }
  };

  const showSelectionArea = (date) => {
    initSelectionArea();

    if (!selectedDateDailyData || selectedDateDailyData.date !== date) {
      selectedDateDailyData = (reservationCalendarData && reservationCalendarData.daily) ? reservationCalendarData.daily.find(data => data.date === date) : null;
    }

    const wday = selectedDateDailyData ? selectedDateDailyData.wday : new Date(date).getDay();
    const isHoliday = selectedDateDailyData ? selectedDateDailyData.holiday === 1 : false;
    dateDisplay.textContent = date.replaceAll("-", "/") + weekdayStr(wday, isHoliday);

    selectionArea.style.display = "block";

    if (!initializing) {
      selectionArea.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    updateStartTimeSelect(date);
  };

  const updateEndTimeSelect = () => {
    initBeforeUpdateEndTimeSelect();

    const startVal = startTimeSelect.value;

    if (!startVal) {
      // 「開始時間」が選択されてしまった場合は初期化した状態で処理を終了する（エラー表示等は行わない）
      return;
    }

    const startSlot = (!isNaN(parseInt(startVal, 10))) ? parseInt(startVal, 10) : null;

    if (startSlot === null) {
      showErrorMessage("利用開始時間が取得できませんでした。時間をおいて再度お試しください。");
      return;
    }

    const dateMatch = dateDisplay.textContent.match(/^(\d{4})\/(\d{2})\/(\d{2})(.*)$/);

    if (!dateMatch) {
      showErrorMessage("予約日時が取得できませんでした。時間をおいて再度お試しください。");
      return;
    }

    const date = `${dateMatch[1]}-${dateMatch[2]}-${dateMatch[3]}`;

    if (!selectedDateDailyData || selectedDateDailyData.date !== date) {
      selectedDateDailyData = (reservationCalendarData && reservationCalendarData.daily) ? reservationCalendarData.daily.find(data => data.date === date) : null;
    }

    if (!calendarSlotData) {
      calendarSlotData = reservationCalendarData ? reservationCalendarData.slot : null;
    }

    const slotMinutes = calendarSlotData ? calendarSlotData.slotMinutes : null;
    const slotsPerDay = calendarSlotData ? calendarSlotData.slotsPerDay : null;

    if (!selectedDateDailyData || !slotMinutes || !slotsPerDay) {
      showErrorMessage("システムエラー: カレンダー情報が見つかりませんでした。");
      return;
    }

    const reducedRsa = reduceRsaDataForEndTime(selectedDateDailyData.rsa, startVal, slotMinutes, slotsPerDay);

    if (!reducedRsa) {
      showErrorMessage("処理中にエラーが発生しました。時間をおいて再度お試しください。");
      return;
    }

    lastSelectedStartTime = slotTime(startSlot, slotMinutes);

    initEndTimeSelect(false);

    const options = generateEndTimeOptions(reducedRsa, slotMinutes);

    if (options.length === 0) {
      endTimeSelect.innerHTML = '<option value="" disabled>予約可能な時間がありません</option>';
    } else {
      options.forEach(opt => {
        const option = document.createElement("option");
        option.value = opt.value;
        option.textContent = opt.text;
        endTimeSelect.appendChild(option);
      });

      const initialSelectedEndTime = lastSelectedEndTime !== null ? lastSelectedEndTime : (initialEndTime !== null ? initialEndTime : null);

      if (initialSelectedEndTime !== null) {
        const matchingEndOption = Array.from(endTimeSelect.options).find(opt => slotTime(opt.value, slotMinutes) === initialSelectedEndTime);
        if (matchingEndOption) {
          endTimeSelect.value = matchingEndOption.value;
          endTimeSelect.dispatchEvent(new Event('change'));
        }
      }
    }
  };

  startTimeSelect.addEventListener("change", () => {
    updateEndTimeSelect();
  });

  // 料金計算
  const updateFeeAndButton = () => {
    initBeforeUpdateFeeAndButton();

    const startVal = startTimeSelect.value;
    const endVal = endTimeSelect.value;

    if (!startVal || !endVal) {
      // 「開始時間」「終了時間」が選択されてしまった場合は初期化した状態で処理を終了する（エラー表示等は行わない）
      return;
    }

    const startSlot = (!isNaN(parseInt(startVal, 10))) ? parseInt(startVal, 10) : null;
    const endSlot = (!isNaN(parseInt(endVal, 10))) ? parseInt(endVal, 10) : null;

    if (startSlot === null || endSlot === null || startSlot >= endSlot) {
      const errorMsg = "利用時間が取得できませんでした。時間をおいて再度お試しください。";
      showErrorMessage(errorMsg);
      errorBottomReserveBtn(errorMsg);
      return;
    }

    const dateMatch = dateDisplay.textContent.match(/^(\d{4})\/(\d{2})\/(\d{2})(.*)$/);

    if (!dateMatch) {
      const errorMsg = "予約日時が取得できませんでした。時間をおいて再度お試しください。";
      showErrorMessage(errorMsg);
      errorBottomReserveBtn(errorMsg);
      return;
    }

    const date = `${dateMatch[1]}-${dateMatch[2]}-${dateMatch[3]}`;

    if (!selectedDateDailyData || selectedDateDailyData.date !== date) {
      selectedDateDailyData = (reservationCalendarData && reservationCalendarData.daily) ? reservationCalendarData.daily.find(data => data.date === date) : null;
    }

    if (!calendarSlotData) {
      calendarSlotData = reservationCalendarData ? reservationCalendarData.slot : null;
    }

    const slotMinutes = calendarSlotData ? calendarSlotData.slotMinutes : null;

    if (!selectedDateDailyData || !slotMinutes) {
      const errorMsg = "システムエラー: カレンダー情報が見つかりませんでした。";
      showErrorMessage(errorMsg);
      errorBottomReserveBtn(errorMsg);
      return;
    }

    const configDiv = document.getElementById("calendar_config");
    const reserveUrl = configDiv ? configDiv.dataset.reserveUrl : null;

    if (!reserveUrl) {
      const errorMsg = "システムエラー: 予約URLが見つかりませんでした。";
      showErrorMessage(errorMsg);
      errorBottomReserveBtn(errorMsg);
      return;
    }

    let baseFeeData = calcBaseFee(selectedDateDailyData.rsa, selectedDateDailyData.rsp, startSlot, endSlot, slotMinutes);

    // 候補を捨てずに保持する。ユーザーが選んだプランが今回の候補に残っていれば維持し、
    // 日時を変えて外れた場合は自動選択（最安・優先度順）に戻す。
    const planCandidates = calcAllFeeData(selectedDateDailyData.rsa, selectedDateDailyData.rsp, startSlot, endSlot, slotMinutes);
    const chosen = userSelectedPu ? planCandidates.find(c => c.pu === userSelectedPu) : null;
    if (userSelectedPu && !chosen) userSelectedPu = null;
    if (chosen) baseFeeData = chosen;

    renderPlanSelection(planCandidates, baseFeeData);

    if (!baseFeeData) {
      const errorMsg = "処理中にエラーが発生しました。時間をおいて再度お試しください。";
      showErrorMessage(errorMsg);
      errorBottomReserveBtn(errorMsg);
      return;
    }

    const startSlotTime = slotTime(startSlot, slotMinutes);
    const endSlotTime = slotTime(endSlot, slotMinutes);
    const startSlotTimeStr = slotTimeStr(startSlotTime);
    const endSlotTimeStr = slotTimeStr(endSlotTime);
    const durationHours = (endSlot - startSlot) * slotMinutes / 60;

    summaryTimeDisplay.innerHTML = `${startSlotTimeStr} - ${endSlotTimeStr} <span class="duration_label">(${durationHours}時間)</span>`;

    if (bottomDateDisplay) bottomDateDisplay.textContent = `${dateMatch[1]}年${dateMatch[2]}月${dateMatch[3]}日${dateMatch[4]}`;
    if (bottomTimeDisplay) {
      bottomTimeDisplay.textContent = `${startSlotTimeStr} - ${endSlotTimeStr}`;
      bottomTimeDisplay.classList.remove("is-empty");
    }

    lastSelectedEndTime = endSlotTime;

    const startHour = Math.floor(startSlotTime / 60);
    const startMinute = startSlotTime % 60;
    const endHour = Math.floor(endSlotTime / 60);
    const endMinute = endSlotTime % 60;

    const reserveUrlQueryParams = new URLSearchParams({
      selected_date: date,
      start_hour: startHour,
      start_minute: startMinute,
      end_hour: endHour,
      end_minute: endMinute,
      pu: baseFeeData.pu,
    });

    const durationMinutes = (endSlot - startSlot) * slotMinutes;

    let optionsFee = 0;
    const checkedOptions = document.querySelectorAll('.detail_checkbox[type="checkbox"]:checked');

    checkedOptions.forEach(opt => {
      const hourlyFee = parseInt(opt.value, 10);
      if (!isNaN(hourlyFee) && durationMinutes > 0) {
        optionsFee += Math.round(hourlyFee * durationMinutes / 60);
      }
      const ou = opt.getAttribute("ou");
      if (ou) reserveUrlQueryParams.append("ou[]", ou);
    });

    const baseFee = baseFeeData.fee;
    const finalFee = baseFee + optionsFee;
    const finalFeeStr = "¥" + finalFee.toString(10).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");

    const finalUrl = `${reserveUrl.split("?")[0]}?${reserveUrlQueryParams.toString()}`;

    totalFeeDisplay.textContent = finalFeeStr;
    renderLastMinute(baseFeeData, optionsFee);

    if (bottomFeeDisplay) bottomFeeDisplay.textContent = finalFeeStr;

    if (reserveBtn.tagName === 'A') {
      reserveBtn.href = finalUrl;
    }
    reserveBtn.textContent = "予約する";
    reserveBtn.classList.remove("is-disabled");
    reserveBtn.classList.remove("detail_button-inactive");
    reserveBtn.classList.add("detail_button-active");

    if (bottomReserveBtn) {
      if (bottomReserveBtn.tagName === 'A') {
        bottomReserveBtn.href = finalUrl;
      }
      bottomReserveBtn.textContent = "予約する";
      bottomReserveBtn.classList.remove("is-disabled");
      bottomReserveBtn.classList.remove("detail_button-inactive");
      bottomReserveBtn.classList.add("detail_button-active");
    }

    // 現在のページURLの変更
    // （予約ページ内から＜ボタンや×ボタンでルーム詳細に戻った際に日時やオプションの選択状態を維持しておきたいのと、
    //   予約前に日時とオプションを選択して料金確認後、LINE等でここどう？みたいな感じで選択状態ごと（料金ごと）グループにシェアするようなユースケースのために、URLに選択状態を保存しておく）
    const currentUrl = new URL(window.location.href);
    currentUrl.search = reserveUrlQueryParams.toString();

    window.history.replaceState(
      history.state,
      "",
      currentUrl.toString()
    );

    showFeeArea();
  };

  endTimeSelect.addEventListener("change", () => {
    updateFeeAndButton();
  });

  // プラン選択（要件B）。候補が2つ以上あるときだけ「変更する」が出る。
  const planChangeBtn = document.getElementById("calendar_plan_change");
  if (planChangeBtn) {
    planChangeBtn.addEventListener("click", () => openPlanModal(currentSelectedPu));
  }

  const planModal = document.getElementById("planSelectModal");
  if (planModal) {
    planModal.addEventListener("click", (event) => {
      const target = event.target;

      if (target.dataset && target.dataset.planModalClose) {
        closePlanModal();
        return;
      }

      if (target.dataset && target.dataset.planSelect) {
        userSelectedPu = target.dataset.planPu;
        closePlanModal();
        updateFeeAndButton();
      }
    });
  }

  // 料金セクションのカードから「このプランで予約する」を押したとき。
  //
  // 日時が未選択だと、そのままでは何も起きたように見えない（予約パネルに出す料金が無いため）。
  // 選んだプランを覚えたことを画面に出し、日付と時間を選ぶよう促す。
  // 日時が選ばれた時点で updateFeeAndButton がこの選択を拾う。
  const showPendingPlan = (pu) => {
    const row = document.getElementById("calendar_plan_row");
    const label = document.getElementById("calendar_selected_plan");
    const changeBtn = document.getElementById("calendar_plan_change");
    const initialMsg = document.getElementById("calendar_initial_message");
    if (!row || !label) return;

    label.textContent = planLabel(pu);
    row.hidden = false;
    if (changeBtn) changeBtn.hidden = true;
    if (initialMsg) initialMsg.textContent = "日付と時間を選ぶと料金が表示されます";
  };

  // 押したその場に結果を出す。
  // 予約パネルは画面の下にあるため、そこだけ変えても「押しても何も起きない」ように見える。
  const markSelectedCard = (button) => {
    document.querySelectorAll(".priceSection_cardButton[data-plan-pu]").forEach((other) => {
      const card = other.closest(".priceSection_card");
      if (card) card.classList.remove("is-selected");
      other.textContent = other.dataset.defaultLabel || other.textContent;
    });

    const card = button.closest(".priceSection_card");
    if (card) card.classList.add("is-selected");
    if (!button.dataset.defaultLabel) button.dataset.defaultLabel = button.textContent;
    button.textContent = "選択中";
  };

  const showPriceSectionNotice = (pu) => {
    const section = document.querySelector(".priceSection");
    if (!section) return;

    let notice = document.getElementById("priceSectionNotice");
    if (!notice) {
      notice = document.createElement("p");
      notice.id = "priceSectionNotice";
      notice.className = "priceSection_notice";
      section.appendChild(notice);
    }
    notice.textContent = `「${planLabel(pu)}」を選びました。このあと空室カレンダーで日付を選ぶと、このプランで料金が計算されます。`;
  };

  // ⚠️ 予約パネル（#calendar_selection_area）は日付を選ぶまで非表示で、高さが0になる。
  //    そこへスクロールしようとするとページ先頭へ飛ぶので、表示されている要素を選ぶ。
  //    日付を選ぶ前はカレンダー本体、選んだ後は予約パネルへ寄せる。
  const scrollToSelectionArea = () => {
    const isVisible = (el) => el && el.offsetParent !== null;

    const area = document.getElementById("calendar_selection_area");
    const dateCell = document.querySelector(".js-calendar-date");
    const target = isVisible(area) ? area : (dateCell ? dateCell.closest("div") : null);
    if (!target) return;

    const top = target.getBoundingClientRect().top + window.pageYOffset - 60;
    window.scrollTo({ top: top < 0 ? 0 : top, behavior: "smooth" });
  };

  document.querySelectorAll(".priceSection_cardButton[data-plan-pu]").forEach((button) => {
    button.addEventListener("click", () => {
      userSelectedPu = button.dataset.planPu;

      const hasDateTime = startTimeSelect && endTimeSelect &&
                          startTimeSelect.value !== "" && endTimeSelect.value !== "";

      markSelectedCard(button);

      if (hasDateTime) {
        updateFeeAndButton();
      } else {
        showPendingPlan(userSelectedPu);
        showPriceSectionNotice(userSelectedPu);
      }

      scrollToSelectionArea();
    });
  });

  const calendarUpdateEnd = () => {
    isLoadingCalendar = false;

    if (pendingMonth && pendingMonth !== lastRequestMonth) {
      const href = calendarNavPrev.getAttribute("href");
      const url = new URL(href, window.location.origin);

      url.searchParams.set("month", pendingMonth);

      isLoadingCalendar = true;
      lastRequestMonth = pendingMonth;
      pendingMonth = null;

      document.dispatchEvent(new CustomEvent("turbo:navigate", { detail: { url: url.pathname + url.search, options: { acceptsStreamResponse: true } } }));
    } else {
      // ローディング非表示
      if (calendarGridWrapper) calendarGridWrapper.classList.remove("is-loading");
    }
  };

  const replaceMonth = (offsetMonth) => {
    const links = [calendarNavPrev, calendarNavNext];

    links.forEach(link => {
      if (link.tagName === 'A') {
        const href = link.getAttribute("href");

        const url = new URL(href, window.location.origin);
        const month = url.searchParams.get("month");

        if (month) {
          const [year, mon] = month.split("-").map(Number);
          const date = new Date(year, mon - 1, 1);

          date.setMonth(date.getMonth() + offsetMonth);

          const newMonth = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}`;

          url.searchParams.set("month", newMonth);

          link.setAttribute("href", url.pathname + url.search);

          let outOfDate = false;
          const minMonth = link.dataset.minMonth;
          if (minMonth) {
            const [minYear, minMon] = minMonth.split("-").map(Number);
            const minDate = new Date(minYear, minMon - 1, 1);

            if (minDate > date) {
              outOfDate = true;
            }
          }

          const maxMonth = link.dataset.maxMonth;
          if (maxMonth) {
            const [maxYear, maxMon] = maxMonth.split("-").map(Number);
            const maxDate = new Date(maxYear, maxMon - 1, 1);

            if (maxDate < date) {
              outOfDate = true;
            }
          }

          if (outOfDate) {
            link.classList.add("disabled");
          } else {
            link.classList.remove("disabled");
          }
        }
      }
    });

    const match = calendarMonthDisplay.textContent.match(/^(\d{4})年(\d{2})月$/);

    if (match) {
      const currentMonth = `${match[1]}-${match[2]}`;
      const [currentYear, currentMon] = currentMonth.split("-").map(Number);
      const currentDate = new Date(currentYear, currentMon - 1, 1);

      currentDate.setMonth(currentDate.getMonth() + offsetMonth);

      calendarMonthDisplay.textContent = `${currentDate.getFullYear()}年${String(currentDate.getMonth() + 1).padStart(2, "0")}月`;
    }
  };

  // 連打されても問題なく動くように、DOMの月を書き換えてからリクエストを飛ばす
  [calendarNavPrev, calendarNavNext].forEach(nav => {
    nav.addEventListener("click", (e) => {
      if (nav.tagName === 'A') {
        e.preventDefault();

        const href = nav.getAttribute("href");
        const url = new URL(href, window.location.origin);
        const month = url.searchParams.get("month");

        if (!month) return;

        const offsetMonth = (nav === calendarNavPrev) ? -1 : 1;
        replaceMonth(offsetMonth);

        // ローディング表示開始
        if (calendarGridWrapper) calendarGridWrapper.classList.add("is-loading");

        if (isLoadingCalendar) {
          pendingMonth = month;
          return;
        }

        isLoadingCalendar = true;
        lastRequestMonth = month;

        document.dispatchEvent(new CustomEvent("turbo:navigate", { detail: { url: href, options: { acceptsStreamResponse: true } } }));
      }
    });
  });

  if (_calendarSelectHandler) {
    document.removeEventListener("calendar:select-date", _calendarSelectHandler);
  }
  _calendarSelectHandler = (e) => {
    const date = e.detail.date;
    if (date) showSelectionArea(date);
    showBottomArea();
  };
  document.addEventListener("calendar:select-date", _calendarSelectHandler);

  if (_calendarUpdateEndHandler) {
    document.removeEventListener("calendar:update-end", _calendarUpdateEndHandler);
  }
  _calendarUpdateEndHandler = () => {
    calendarUpdateEnd();
  };
  document.addEventListener("calendar:update-end", _calendarUpdateEndHandler);

  // URLで日付が選択されている場合はその日付を選択状態にしておく
  const initialDate = urlParams.get('selected_date');
  if (initialDate) {
    const dateCell = document.querySelector(`.js-calendar-date[data-date="${initialDate}"]`);
    if (dateCell) dateCell.click();
  }

  initializing = false;
};

// イベント委譲: Turbo Frame更新後も日付クリックが動作するように
document.addEventListener("click", (e) => {
  const dateCell = e.target.closest(".js-calendar-date");
  if (dateCell) {
    document.querySelectorAll(".js-calendar-date").forEach(cell => {
      cell.classList.remove("is-selected");
    });
    dateCell.classList.add("is-selected");

    const date = dateCell.dataset.date;
    if (date) {
      document.dispatchEvent(new CustomEvent("calendar:select-date", { detail: { date } }));
    }
  }
});

// turbo-stream actionを使ってデータを受け渡しするため、カスタムイベントを登録
// カレンダーデータが確実に初期化されてからinitCalendarを実行
document.addEventListener("calendar:data-initialize", (e) => {
  if (e.detail.data) {
    const data = JSON.parse(e.detail.data);
    reservationCalendarData = data;
    calendarSlotData = data.slot;

    initCalendar();
  }
});

// turbo-stream actionを使ってデータを受け渡しするため、カスタムイベントを登録
document.addEventListener("calendar:data-update", (e) => {
  if (e.detail.data) {
    const data = JSON.parse(e.detail.data);
    reservationCalendarData = data;
    calendarSlotData = data.slot;
  }
});

document.addEventListener("turbo:load", () => {
  const selectionArea = document.getElementById("calendar_selection_area");

  if (!selectionArea) {
    // カレンダーが不要なページでは各種変数は初期化（削除）しておく
    clearCalendarVariables();
    return;
  }
});

// input type="number" のスクロールによる数値変更を防ぐ（フォーカスを維持しつつページスクロールを許可する）
let wheelTimeout;
document.addEventListener("wheel", function (e) {
  if (e.target.tagName === "INPUT" && e.target.type === "number" && document.activeElement === e.target) {
    e.target.readOnly = true;
    clearTimeout(wheelTimeout);
    wheelTimeout = setTimeout(() => {
      e.target.readOnly = false;
    }, 100);
  }
});
// 料金セクション（部屋詳細）の折りたたみ
// 閾値を超えたルームは既定で畳んでおり、料金のレンジだけを見せる。
// 展開状態はURLに持たない（単なる開閉）。
function initializePriceSectionToggle() {
  const toggle = document.getElementById("priceSectionToggle");
  if (!toggle) return;

  const section = toggle.closest(".priceSection");
  if (!section) return;

  toggle.addEventListener("click", function () {
    const expanded = section.classList.toggle("is-expanded");
    toggle.setAttribute("aria-expanded", expanded ? "true" : "false");
    toggle.textContent = expanded
      ? (toggle.dataset.closeLabel || "料金をとじる")
      : (toggle.dataset.openLabel || "すべての料金を見る");
  });
}

$(document).on("turbo:load", initializePriceSectionToggle);
